// =====================================================
// KB-CART-INDIVIDUALISIERUNG.JS
// Personalize your loops right in your cart
// =====================================================

(function() {
  // =====================
  // ⚙️ CLOUDINARY
  // =====================
  const CLOUDINARY_CONFIG = {
    cloudName: 'dcyed4r74',
    uploadPreset: 'massenbestellung',
    folder: 'massenbestellung'
  };

  // =====================
  // Language detection function (FIRST!)
  // =====================
  function getCurrentLanguage() {
    const domain = window.location.hostname;
    if (domain.includes("dk.toproset")) return "dk";
    if (domain.includes("nl.toproset")) return "nl";
    if (domain.includes("es.toproset")) return "es";
    if (domain.includes("en.toproset")) return "en";
    return "de";
  }

  // =====================
  // Language texts
  // =====================
  const LANG = getCurrentLanguage();
  console.log('Current language:', getCurrentLanguage())
  const T = {
    de: {
      title: "Individuelle Beschriftung",
      btnOpen: "Individualisieren",
      btnEdit: "Bearbeiten",
      btnSave: "Speichern",
      btnCancel: "Abbrechen",
      labelBand: "Text auf Band",
      vipBadge: "VIP",
      vipPlusBadge: "VIP+",
      labelVipPlusBand: "Text auf VIP+ Band",
      // --- Zentrum label ---
      labelZentrum: "Zentrumstyp",                              // legacy
      labelZentrum_new: "Aufdruck auf Zentrum auswählen",       // new
      // --- Zentrum color label ---
      labelZentrumColor: "Zentrumsfarbe",                       // legacy
      labelZentrumColor_new: "Farbe des Zentrums",              // new
      labelTemplateNo: "Artikelnr. der Vorlage",
      labelOR: "oder",
      labelUploadCloudinary: "☁️ Bild hochladen",
      image_load_hint: "Druckvorlage nicht verfügbar ? Kein Problem!\n   Bitte Vorgang abspeichern und Druckvorlage in einer separaten E-Mail mit Angaben der Auftragsnummer hochladen\noder am Ende der Bestellung in dem Feld  «Mitteilung an den Lieferanten» weitere Angaben schreiben.",
      labelCurrentImage: "Aktuelles Bild:",
      labelTemplates: "Vorlagen",
      labelMaterial: "Material",
      centerMaterial: "Material",                               // legacy
      centerMaterial_new: "Material des Zentrums",              // new
      btnRemoveImage: "Bild entfernen",
      // --- options ---
      optionBlank: "Blanco ohne Aufdruck",                      // legacy (was "Blanco ohne Aufdruck", no change)
      optionBlank_new: "Blanco ohne Aufdruck",                  // new
      optionStandard: "Vorlagen",                               // legacy
      optionStandard_new: "Vorlagen",                           // new (same for now)
      optionDigital: "Mehrfarbiger Digitaldruck",               // legacy
      optionDigital_new: "Mehrfarbiger Digitaldruck",           // new (same for now)
      optionFoil: "Einfarbiger Foliendruck",                    // legacy
      optionFoil_new: "Prägedruck mit einfarbiger Folie",       // new
      // --- material options ---
      materialMetall: "Hochwertiges Metall",                    // legacy
      materialMetall_new: "Hochwertiges Metall",                // new (same for now)
      materialPlastic: "Kunststoff",
      msgSaved: "Änderungen gespeichert",
      msgError: "Fehler beim Speichern",
      msgImageUploaded: "Bild erfolgreich hochgeladen!",
      msgImageRemoved: "Bild entfernt",
      keywords: ["Schleife ", "Konfigurator"],
      bandKeyword: "Bänder",
      totalQuantity: "Gesamtmenge:",
      pieces: "Stk",
      btnUploadExcel: "📊 Excel",
      maxRows: "Max. Zeilen:",
      maxLength: "Max. Zeichenlänge:",
      placeholderLine1: "Zeile 1 (max 35 Zeichen)",
      placeholderLine2: "Zeile 2 (max 35 Zeichen)",
      charCounter: "Zeile",
      quantity: "Menge",
      row: "Zeile",
      msgProcessing: "Verarbeite...",
      msgUploaded: "{count} Texte geladen",
      msgNoData: "Keine Daten gefunden",
      msgInvalidFile: "Ungültiger Dateityp",
      selectAll: "Alle",
      deselectAll: "Keine",
      deleteSelected: "Löschen",
      konfigurator_sku: '1000000',
      montageVIP:    'VIP montiert',
      montageNormal: 'Fächer montiert',
      vipPlusNone:   'Kein VIP plus',
      bandCountKey: "Anzahl der Bänder",
      ribbonBlocked: "Kein Textdruck möglich",
      notAvailable: "Nicht verfügbar"
    },
    en: {
      title: "Individual customization",
      btnOpen: "Customize",
      btnEdit: "Edit",
      btnSave: "Save",
      btnCancel: "Cancel",
      labelBand: "Text on ribbon",
      vipBadge: "VIP",
      vipPlusBadge: "VIP+",
      labelVipPlusBand: "Text on VIP+ ribbon",
      labelZentrum: "Center type",                              // legacy
      labelZentrum_new: "Select center print",                  // new
      labelZentrumColor: "Center color",                        // legacy
      labelZentrumColor_new: "Print on center",                    // new (same for now)
      labelTemplateNo: "Template article no.",
      labelOR: "or",
      labelUploadCloudinary: "☁️ Upload image",
      image_load_hint: "Print template not available? No problem!\n Please save the process and send the print template in a separate email, including the order number,\nor add further details at the end of the order in the «Message to the supplier» field.",
      labelCurrentImage: "Current image:",
      labelTemplates: "Templates",
      labelMaterial: "Material",
      centerMaterial: "Material",                               // legacy
      centerMaterial_new: "Center material",                    // new
      btnRemoveImage: "Remove image",
      optionBlank: "Blank (no print)",                          // legacy
      optionBlank_new: "Blank (no print)",                      // new (same for now)
      optionStandard: "Templates",                              // legacy
      optionStandard_new: "Templates",                          // new (same for now)
      optionDigital: "Multicolor digital print",                // legacy
      optionDigital_new: "Multicolor digital print",            // new (same for now)
      optionFoil: "Single-color foil printing",                 // legacy
      optionFoil_new: "Embossed print with single-color foil",  // new
      materialMetall: "High-quality metal",                     // legacy
      materialMetall_new: "High-quality metal",                 // new (same for now)
      materialPlastic: "Plastic",
      msgSaved: "Changes saved",
      msgError: "Error saving",
      msgImageUploaded: "Image uploaded successfully!",
      msgImageRemoved: "Image removed",
      keywords: ["Loop ", "Configurator"],
      bandKeyword: "Ribbons",
      totalQuantity: "Total quantity:",
      pieces: "pcs",
      btnUploadExcel: "📊 Excel",
      maxRows: "Max. rows:",
      maxLength: "Max. text length:",
      placeholderLine1: "Line 1 (max 35 characters)",
      placeholderLine2: "Line 2 (max 35 characters)",
      charCounter: "Line",
      quantity: "Qty",
      row: "Row",
      msgProcessing: "Processing...",
      msgUploaded: "{count} texts loaded",
      msgNoData: "No data found",
      msgInvalidFile: "Invalid file type",
      selectAll: "All",
      deselectAll: "None",
      deleteSelected: "Delete",
      konfigurator_sku: '1000000',
      montageVIP:    'VIP assembled',
      montageNormal: 'Fan assembled',
      vipPlusNone:   'No VIP plus',
      bandCountKey: "Number of ribbons",
      ribbonBlocked: "Kein Textdruck möglich",
      notAvailable: "Nicht verfügbar"
    },
    es: {
      title: "Personalización individual",
      btnOpen: "Personalizar",
      btnEdit: "Editar",
      btnSave: "Guardar",
      btnCancel: "Cancelar",
      labelBand: "Texto en cinta",
      vipBadge: "VIP",
      vipPlusBadge: "VIP+",
      labelVipPlusBand: "Texto en el VIP+ cinta",
      labelZentrum: "Tipo de centro",                                     // legacy
      labelZentrum_new: "Seleccionar impresión en el centro",             // new
      labelZentrumColor: "Color del centro",                              // legacy
      labelZentrumColor_new: "Color del centro",                          // new (same for now)
      labelTemplateNo: "N.º de artículo de la plantilla",
      labelOR: "o",
      labelUploadCloudinary: "☁️ Subir imagen",
      image_load_hint: "¿No tienes disponible la plantilla de impresión? ¡No hay problema!\n Guarda el proceso y envía la plantilla en un correo electrónico aparte indicando el número de pedido,\no bien escribe más información al final del pedido en el campo «Mensaje al proveedor».",
      labelCurrentImage: "Imagen actual:",
      labelTemplates: "Plantillas",
      labelMaterial: "Material",
      centerMaterial: "Material",                                          // legacy
      centerMaterial_new: "Material del centro",                          // new
      btnRemoveImage: "Eliminar imagen",
      optionBlank: "En blanco (sin impresión)",                           // legacy
      optionBlank_new: "En blanco (sin impresión)",                       // new (same for now)
      optionStandard: "Plantillas",                                        // legacy
      optionStandard_new: "Plantillas",                                    // new (same for now)
      optionDigital: "Impresión digital multicolor",                       // legacy
      optionDigital_new: "Impresión digital multicolor",                   // new (same for now)
      optionFoil: "Impresión en foil de un solo color",                   // legacy
      optionFoil_new: "Impresión en relieve con foil de un solo color",   // new
      materialMetall: "Metal de alta calidad",                             // legacy
      materialMetall_new: "Metal de alta calidad",                         // new (same for now)
      materialPlastic: "Plástico",
      msgSaved: "Cambios guardados",
      msgError: "Error al guardar",
      msgImageUploaded: "¡Imagen subida con éxito!",
      msgImageRemoved: "Imagen eliminada",
      keywords: ["Escarapela ", "Configurador"],
      bandKeyword: "Cintas",
      totalQuantity: "Cantidad total:",
      pieces: "uds",
      btnUploadExcel: "📊 Excel",
      maxRows: "Máx. filas:",
      maxLength: "Longitud máx. del texto:",
      placeholderLine1: "Línea 1 (máx. 35 caracteres)",
      placeholderLine2: "Línea 2 (máx. 35 caracteres)",
      charCounter: "Línea",
      quantity: "Cantidad",
      row: "Fila",
      msgProcessing: "Procesando...",
      msgUploaded: "{count} textos cargados",
      msgNoData: "No se encontraron datos",
      msgInvalidFile: "Tipo de archivo no válido",
      selectAll: "Todo",
      deselectAll: "Nada",
      deleteSelected: "Eliminar",
      konfigurator_sku: '1000000',
      montageVIP:    'Montado VIP',
      montageNormal: 'Montado en abanico',
      vipPlusNone:   'Sin VIP plus',
      bandCountKey: "Cantidad de cintas",
      ribbonBlocked: "No es posible la impresión de texto",
      notAvailable: "No disponible"      
    },
    nl: {
      title: "Individuele personalisatie",
      btnOpen: "Individualiseren",
      btnEdit: "Bewerken",
      btnSave: "Opslaan",
      btnCancel: "Annuleren",
      labelBand: "Tekst op lint",
      vipBadge: "VIP",
      vipPlusBadge: "VIP+",
      labelVipPlusBand: "Tekst op VIP+ lint",
      labelZentrum: "Type centrum",                                 // legacy
      labelZentrum_new: "Opdruk op het centrum kiezen",            // new
      labelZentrumColor: "Centrumkleur",                           // legacy
      labelZentrumColor_new: "Kleur van het centrum",              // new
      labelTemplateNo: "Artikelnummer van het sjabloon",
      labelOR: "of",
      labelUploadCloudinary: "☁️ Afbeelding uploaden",
      image_load_hint: " Druksjabloon niet beschikbaar? Geen probleem!\n Sla het proces op en stuur het druksjabloon in een aparte e-mail met vermelding van het ordernummer,\nof schrijf aan het einde van de bestelling extra informatie in het veld «Bericht aan de leverancier».",
      labelCurrentImage: "Huidige afbeelding:",
      labelTemplates: "Sjablonen",
      labelMaterial: "Materiaal",
      centerMaterial: "Materiaal",                                  // legacy
      centerMaterial_new: "Materiaal van het centrum",             // new
      btnRemoveImage: "Afbeelding verwijderen",
      optionBlank: "Blanco (zonder opdruk)",                       // legacy
      optionBlank_new: "Blanco (zonder opdruk)",                   // new (same for now)
      optionStandard: "Sjablonen",                                  // legacy
      optionStandard_new: "Sjablonen",                              // new (same for now)
      optionDigital: "Meerkleurige digitale druk",                 // legacy
      optionDigital_new: "Meerkleurige digitale druk",             // new (same for now)
      optionFoil: "Eenkleurige foliedruk",                         // legacy
      optionFoil_new: "Preegdruk met eenkleurige folie",           // new
      materialMetall: "Hoogwaardig metaal",                         // legacy
      materialMetall_new: "Hoogwaardig metaal",                     // new (same for now)
      materialPlastic: "Kunststof",
      msgSaved: "Wijzigingen opgeslagen",
      msgError: "Fout bij opslaan",
      msgImageUploaded: "Afbeelding succesvol geüpload!",
      msgImageRemoved: "Afbeelding verwijderd",
      keywords: ["Lint", "onfigurator"],
      bandKeyword: "Linten",
      totalQuantity: "Totale hoeveelheid:",
      pieces: "st",
      btnUploadExcel: "📊 Excel",
      maxRows: "Max. rijen:",
      maxLength: "Max. tekstlengte:",
      placeholderLine1: "Regel 1 (max. 35 tekens)",
      placeholderLine2: "Regel 2 (max. 35 tekens)",
      charCounter: "Regel",
      quantity: "Aantal",
      row: "Rij",
      msgProcessing: "Verwerken...",
      msgUploaded: "{count} teksten geladen",
      msgNoData: "Geen gegevens gevonden",
      msgInvalidFile: "Ongeldig bestandstype",
      selectAll: "Alles",
      deselectAll: "Geen",
      deleteSelected: "Verwijderen",
      konfigurator_sku: '1000000',
      montageVIP:    'VIP gemonteerd',
      montageNormal: 'Plissé gemonteerd',
      vipPlusNone:   'Geen VIP plus',
      bandCountKey: "Aantal linten",
      ribbonBlocked: "Geen tekstdruk mogelijk",
      notAvailable: "Niet beschikbaar"      
    },
    dk: {
      title: "Individuel tilpasning",
      btnOpen: "Tilpas",
      btnEdit: "Rediger",
      btnSave: "Gem",
      btnCancel: "Annuller",
      labelBand: "Tekst på bånd",
      vipBadge: "VIP",
      vipPlusBadge: "VIP+",
      labelVipPlusBand: "Tekst på VIP+ band",
      labelZentrum: "Centertype",                                   // legacy
      labelZentrum_new: "Vælg tryk på center",                     // new
      labelZentrumColor: "Centerfarve",                             // legacy
      labelZentrumColor_new: "Centerfarve",                         // new (same for now)
      labelTemplateNo: "Varenr. på skabelonen",
      labelOR: "eller",
      labelUploadCloudinary: "☁️ Upload billede",
      image_load_hint: "Druksjabloon niet beschikbaar? Geen probleem!\n Sla het proces op en stuur het druksjabloon in een aparte e-mail met vermelding van het ordernummer,\nof schrijf aan het einde van de bestelling extra informatie in het veld «Bericht aan de leverancier».",
      labelCurrentImage: "Nuværende billede:",
      labelTemplates: "Skabeloner",
      labelMaterial: "Material",
      centerMaterial: "Material",                                   // legacy
      centerMaterial_new: "Centermateriale",                        // new
      btnRemoveImage: "Fjern billede",
      optionBlank: "Blank",                                         // legacy
      optionBlank_new: "Blank (uden tryk)",                         // new
      optionStandard: "Skabeloner",                                  // legacy
      optionStandard_new: "Skabeloner",                              // new (same for now)
      optionDigital: "Flerfarvet digitaltryk",                      // legacy
      optionDigital_new: "Flerfarvet digitaltryk",                  // new (same for now)
      optionFoil: "Enkeltfarvet folietryk",                         // legacy
      optionFoil_new: "Prægtryk med ensfarvet folie",               // new
      materialMetall: "Højkvalitets metal",                         // legacy
      materialMetall_new: "Højkvalitets metal",                     // new (same for now)
      materialPlastic: "Plast",
      msgSaved: "Ændringer gemt",
      msgError: "Fejl ved lagring",
      msgImageUploaded: "Billede uploadet!",
      msgImageRemoved: "Billede fjernet",
      keywords: ["Roset ", "Konfigurator"],
      bandKeyword: "Bånd",
      totalQuantity: "Samlet mængde:",
      pieces: "stk",
      btnUploadExcel: "📊 Excel",
      maxRows: "Maks. rækker:",
      maxLength: "Maks. tekstlængde:",
      placeholderLine1: "Linje 1 (maks. 35 tegn)",
      placeholderLine2: "Linje 2 (maks. 35 tegn)",
      charCounter: "Linje",
      quantity: "Antal",
      row: "Række",
      msgProcessing: "Behandler...",
      msgUploaded: "{count} tekster indlæst",
      msgNoData: "Ingen data fundet",
      msgInvalidFile: "Ugyldig filtype",
      selectAll: "Alle",
      deselectAll: "Ingen",
      deleteSelected: "Slet",
      konfigurator_sku: '1000000',
      montageVIP:    'VIP monteret',
      montageNormal: 'Vifte monteret',
      vipPlusNone:   'Ingen VIP plus',
      bandCountKey: "Antal bånd",
      ribbonBlocked: "Teksttryk ikke muligt",
      notAvailable: "Ikke tilgængelig"      
    }
  }[LANG] || T.de;

  // =====================
  // Helper: does the value match the old OR new key version?
  // Use wherever we read props and compare with T.optionXxx
  // =====================
  function matchOption(value, key) {
    if (!value) return false;
    const legacy = T[key];
    const current = T[key + '_new'] !== undefined ? T[key + '_new'] : legacy;
    return value === legacy || value === current;
  }

  // =====================
  // Property names by language
  // =====================
  const PROPERTY_NAMES = {
    de: {
      band: "Text auf Band",
      bandQty: "Menge Band",
      bandDetails: "_Band Details",
      center: "Zentrumstyp",                  // legacy key name
      center_new: "Aufdruck auf Zentrum",              // new key name (same in DE, update if configurator changes key)
      centerColor: "Zentrumsfarbe",           // legacy
      centerColor_new: "Farbe des Zentrums",       // new (same in DE)
      centerQty: "Zentrum Menge",
      centerMaterial: "Material",             // legacy
      centerMaterial_new: "Material des Zentrums", // new
      templateNo: "Artikelnr. der Vorlage",
      templateName: "Vorlage",
      imageUrl: "Druckvorlage hochladen"
    },
    en: {
      band: "Text on ribbon",
      bandQty: "Ribbon quantity",
      bandDetails: "_Ribbon details",
      center: "Center type",                  // legacy
      center_new: "Print on center",              // new (same for now)
      centerColor: "Center color",            // legacy
      centerColor_new: "Center color",        // new (same for now)
      centerQty: "Center quantity",
      centerMaterial: "Material",             // legacy
      centerMaterial_new: "Center material",  // new
      templateNo: "Template article no.",
      templateName: "Template",
      imageUrl: "Upload print template"
    },
    dk: {
      band: "Tekst på bånd",
      bandQty: "Bånd antal",
      bandDetails: "_Bånd detaljer",
      center: "Centertype",                   // legacy
      center_new: "Tryk på center",               // new (same for now)
      centerColor: "Centerfarve",             // legacy
      centerColor_new: "Centerfarve",         // new (same for now)
      centerQty: "Center antal",
      centerMaterial: "Material",             // legacy
      centerMaterial_new: "Centermateriale",  // new
      templateNo: "Varenr. på skabelonen",
      templateName: "Skabelon",
      imageUrl: "Upload printskabelon"
    },
    nl: {
      band: "Tekst op lint",
      bandQty: "Lint hoeveelheid",
      bandDetails: "_Lint details",
      center: "Type centrum",                           // legacy
      center_new: "Opdruk op het centrum",                       // new (same for now)
      centerColor: "Centrumkleur",                      // legacy
      centerColor_new: "Kleur van het centrum",         // new
      centerQty: "Centrum hoeveelheid",
      centerMaterial: "Materiaal",                      // legacy
      centerMaterial_new: "Materiaal van het centrum",  // new
      templateNo: "Artikelnummer van het sjabloon",
      templateName: "Sjabloon",
      imageUrl: "Upload drukvoorbeeld"
    },
    es: {
      band: "Texto en el cinta",
      bandQty: "Cantidad de cintas",
      bandDetails: "_Detalles de cinta",
      center: "Tipo de centro",                                   // legacy
      center_new: "Impresión en el centro",                       // new (same for now)
      centerColor: "Color del centro",                            // legacy
      centerColor_new: "Color del centro",                        // new (same for now)
      centerQty: "Cantidad de centro",
      centerMaterial: "Material",                                 // legacy
      centerMaterial_new: "Material del centro",                  // new
      templateNo: "N.º de artículo de la plantilla",
      templateName: "Plantilla",
      imageUrl: "Subir plantilla de impresión"
    }
  };

  // =====================
  // Helper: read property by key with fallback to legacy and _new options
  // =====================
  function readProp(props, P, key) {
    // Сначала пробуем новый ключ, потом legacy
    const newKey = P[key + '_new'];
    const legacyKey = P[key];
    if (newKey && props[newKey] !== undefined) return props[newKey];
    if (legacyKey && props[legacyKey] !== undefined) return props[legacyKey];
    return undefined;
  }

  const PRODUCT_HANDLES = {
    CENTER_COLORS: {
      de: 'zentrum-blanco',
      en: 'zentrum-blanco',
      nl: 'zentrum-blanco',
      es: 'zentrum-blanco',
      dk: 'zentrum-blanco'
    },
    CENTER_TEMPLATES: {
      de: 'standardvorlagen',
      en: 'standard-templates',
      nl: 'standaard-sjablonen',
      es: 'plantillas-estandar',
      dk: 'standard-skabeloner'
    }
  };
  // Глобальные переменные
  let isInitialized = false;
  let observerInstance = null;
  let ribbonCount = 3;
  let currentItemData = {};
  let bandTexts = {}; // { 1: [{text, qty}], 2: [{text, qty}], ... }
  let currentImageUrl = '';
  let currentImagePublicId = '';
  let currentImageTitle = '';
  let currentImageSource = '';
  let cloudinaryWidget = null;

  let centerColorsCache = null;
  let centerTemplatesCache = null;
  const CENTER_COLORS_PRODUCT_HANDLE = PRODUCT_HANDLES.CENTER_COLORS[LANG] || 'zentrum-blanco';
  const CENTER_TEMPLATES_PRODUCT_HANDLE = PRODUCT_HANDLES.CENTER_TEMPLATES[LANG] || 'standardvorlagen';

  // Settings for Excel
  const EXCEL_CONFIG = {
    maxRows: 70,
    maxLineLength: 35,
    maxLines: 2,
    supportedFormats: ['.xlsx', '.xls', '.csv']
  };
  const VIP_PLUS_CONFIG = {
    maxLines: 2,
    maxLineLength: 35
  };

  const VIP_PLUS_50_CONFIG = {
    maxLines: 5,   
    maxLineLength: 12
  };

  // Schärpen
  const TEXT_DISABLED_SKUS = ['23915', '23910'];

  function isTextDisabled() {
    const sku = (currentItemData.sku || '').toString().trim();
    if (!sku) return false;
    // startsWith — на случай SKU вида "23915-01"
    return TEXT_DISABLED_SKUS.some(s => sku === s || sku.startsWith(s));
  }
  // =====================
  // Initialization
  // =====================
  function init() {
    if (isInitialized) return;
    isInitialized = true;

    console.log("🚀 Initializing cart individualisierung...");
    
    if (typeof cloudinary === 'undefined') {
      console.warn('⚠️ Cloudinary Upload Widget not loaded');
    } else {
      console.log('✅ Cloudinary Upload Widget loaded');
    }
    
    createModal();
    addIndividualisierungButtons();
    setupMutationObserver();
    
    document.addEventListener("click", handleButtonClick);
  }

  document.addEventListener("DOMContentLoaded", () => {
    setTimeout(init, 500);
  });


  // =====================
  // MutationObserver
  // =====================
  function setupMutationObserver() {
    const cartTable = document.getElementById("cart-table");
    if (!cartTable) {
      console.warn("⚠️ Cart table not found");
      return;
    }

    if (observerInstance) {
      observerInstance.disconnect();
    }

    observerInstance = new MutationObserver(() => {
      setTimeout(() => {
        addIndividualisierungButtons();
      }, 100);
    });

    observerInstance.observe(cartTable, {
      childList: true,
      subtree: true
    });

    console.log("👁️ MutationObserver set up");
  }


  // =====================
  // Modal
  // =====================
  function createModal() {
    if (document.getElementById("individ-modal")) return;

    const modal = document.createElement("div");
    modal.id = "individ-modal";
    modal.style.cssText = `
      display:none;position:fixed;top:0;left:0;width:100%;height:100%;
      background:rgba(0,0,0,0.6);z-index:9999;align-items:center;justify-content:center;
    `;

    modal.innerHTML = `
      <div id="individ-content" style="
        background:#fff;padding:30px;border-radius:8px;width:90%;max-width:800px;
        box-shadow:0 4px 20px rgba(0,0,0,0.3);position:relative;max-height:90vh;overflow-y:auto;">
        
        <h3 style="margin-top:0;color:#910045;border-bottom:2px solid #910045;padding-bottom:10px;">${T.title}</h3>

        <!-- Общее количество -->
        <div id="total-quantity-display" style="background:#f0f8f0;padding:15px;border-radius:6px;margin-bottom:20px;border:2px solid #4CAF50;display:none;">
          <div style="display:flex;justify-content:space-between;align-items:center;">
            <strong style="font-size:16px;color:#2e7d32;">${T.totalQuantity}</strong>
            <span id="total-quantity-value" style="font-size:24px;font-weight:bold;color:#2e7d32;">0</span>
          </div>
        </div>

        <div class="individ-fields" id="individ-fields-container" style="display:flex;flex-direction:column;gap:15px;margin-top:20px;">
          <!-- Поля будут добавлены динамически -->
        </div>

        <div style="margin-top:25px;text-align:right;display:flex;gap:10px;justify-content:flex-end;">
          <button id="individ-cancel" class="btn-cancel" style="padding:12px 24px;background:#ccc;border:none;border-radius:0px;cursor:pointer;font-size:14px;font-weight:bold;">${T.btnCancel}</button>
          <button id="individ-save" class="btn-save" style="padding:12px 24px;background:#910045;color:white;border:none;border-radius:0px;cursor:pointer;font-size:14px;font-weight:bold;">${T.btnSave}</button>
        </div>
      </div>
    `;

    document.body.appendChild(modal);

    document.getElementById("individ-cancel").addEventListener("click", closeModal);
    modal.addEventListener("click", e => {
      if (e.target === modal) closeModal();
    });

    document.getElementById("individ-save").addEventListener("click", saveIndividualisierung);
  }


  // =====================
  // Update the total display
  // =====================
  function updateTotalQuantity() {
    let total = 0;

    let hasMultipleTexts = false;
    for (let i = 1; i <= ribbonCount; i++) {
      const texts = bandTexts[i] || [];
      if (texts.length > 1) {
        hasMultipleTexts = true;
        break;
      }
    }

    if (hasMultipleTexts) {
      for (let i = 1; i <= ribbonCount; i++) {
        const texts = bandTexts[i] || [];
        const bandTotal = texts.reduce((sum, t) => sum + t.quantity, 0);
        total = Math.max(total, bandTotal);
      }
    } else {
      total = currentItemData.quantity || 0;
    }

    const display = document.getElementById('total-quantity-display');
    const value = document.getElementById('total-quantity-value');
    
    if (display && value) {
      if (total > 0) {
        display.style.display = 'block';
        value.textContent = total;
      } else {
        display.style.display = 'none';
      }
    }

    return total;
  }


  // =====================
  // Initializing Cloudinary Widget
  // =====================
  function initCloudinaryWidget() {
    if (typeof cloudinary === 'undefined') {
      console.error('Cloudinary widget library not loaded');
      alert('Cloudinary Upload Widget nicht verfügbar. Bitte Seite neu laden.');
      return null;
    }

    if (cloudinaryWidget) {
      return cloudinaryWidget;
    }

    cloudinaryWidget = cloudinary.createUploadWidget(
      {
        cloudName: CLOUDINARY_CONFIG.cloudName,
        uploadPreset: CLOUDINARY_CONFIG.uploadPreset,
        folder: CLOUDINARY_CONFIG.folder,
        sources: ['local', 'url', 'camera'],
        multiple: false,
        maxFiles: 1,
        clientAllowedFormats: ['png', 'jpg', 'jpeg', 'gif', 'webp', 'svg', 'pdf'],
        maxFileSize: 10000000,
      },
      (error, result) => {
        if (error) {
          console.error('❌ Cloudinary upload error:', error);
          alert(T.msgError + ': ' + error.message);
          return;
        }
        
        if (result.event === 'success') {
          handleCloudinaryUploadSuccess(result.info);
        }
      }
    );

    return cloudinaryWidget;
  }


  // =====================
  // Generating a thumbnail URL
  // =====================
  function generateThumbnailUrl(publicId, width = 80, height = 80) {
    return `https://res.cloudinary.com/${CLOUDINARY_CONFIG.cloudName}/image/upload/c_fit,w_${width},h_${height}/${publicId}`;
  }

  // =====================
  // Processing a successful upload to Cloudinary
  // =====================
  function handleCloudinaryUploadSuccess(info) {
    const { secure_url, public_id, original_filename } = info;
    
    currentImageUrl = secure_url;
    currentImagePublicId = public_id;
    currentImageTitle = original_filename;
    currentImageSource = 'cloudinary';
    
    console.log('📷 Image uploaded:', {
      url: secure_url,
      publicId: public_id,
      filename: original_filename
    });
    
    const thumbnailUrl = generateThumbnailUrl(public_id, 150, 150);
    updateImagePreview(thumbnailUrl, original_filename);
    
    alert(T.msgImageUploaded);
  }


  // =====================
  // Refresh preview image
  // =====================
  function updateImagePreview(thumbnailUrl, filename) {
    const container = document.getElementById('image-preview-container');
    if (!container) return;

    if (thumbnailUrl) {
      let displayHTML = '';
      
      if (currentImageSource === 'template') {
        const displayName = filename || currentImageTitle || 'Template';
        displayHTML = `
          <span style="color:#910045;font-weight:bold;">
            ${displayName}
          </span>
        `;
      } else if (currentImageSource === 'cloudinary') {
        displayHTML = `
          <a href="${currentImageUrl}" target="_blank" rel="noopener noreferrer" 
            style="color:#910045;text-decoration:none;font-size:20px;">
            🔍
          </a>
        `;
      } else {
        const displayName = filename || currentImageTitle || 'Bild ansehen';
        displayHTML = `
          <span style="color:#910045;font-weight:bold;">
            ${displayName}
          </span>
        `;
      }
      
      container.innerHTML = `
        <div style="margin-top:10px;padding:15px;background:#f0f8f0;border:1px solid #4CAF50;border-radius:6px;">
          <div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:10px;">
            <strong style="color:#2e7d32;font-size:14px;">${T.labelCurrentImage}</strong>
            <button type="button" onclick="window.removeCurrentImage()" 
              style="padding:5px 10px;background:#f44336;color:white;border:none;border-radius:0px;cursor:pointer;font-size:12px;font-weight:bold;">
              ${T.btnRemoveImage}
            </button>
          </div>
          <div style="text-align:center;margin:15px 0;">
            <img src="${thumbnailUrl}" alt="${filename || currentImageTitle || 'Preview'}" 
              style="max-width:150px;max-height:150px;border-radius:6px;box-shadow:0 2px 8px rgba(0,0,0,0.1);">
          </div>
          <div style="font-size:12px;color:#666;text-align:center;">
            ${displayHTML}
          </div>
        </div>
      `;
    } else {
      container.innerHTML = '';
    }
  }


  // =====================
  // Delete the current image
  // =====================
  window.removeCurrentImage = function() {
    if (confirm(T.btnRemoveImage + '?')) {
      currentImageUrl = '';
      currentImagePublicId = '';
      currentImageTitle = '';
      currentImageSource = '';
      updateImagePreview(null, null);
      alert(T.msgImageRemoved);
    }
  };

  // =====================
  // Load center colors from product
  // =====================
  async function loadCenterColors() {
    if (centerColorsCache) {
      console.log('✅ Using cached center colors');
      return centerColorsCache;
    }

    try {
      console.log('📥 Loading center colors from product...');
      const response = await fetch(`/products/${CENTER_COLORS_PRODUCT_HANDLE}.js`);
      
      if (!response.ok) {
        throw new Error(`Failed to load product: ${response.status}`);
      }
      
      const product = await response.json();
      const colors = [];
      
      product.variants.forEach(variant => {
        if (variant.option1 && !colors.includes(variant.option1)) {
          colors.push(variant.option1);
        }
      });
      
      centerColorsCache = colors;
      console.log('✅ Loaded center colors:', colors);
      return colors;
      
    } catch (error) {
      console.error('❌ Failed to load center colors:', error);
      return [];
    }
  }

  // =====================
  // Fill the dropdown with colors
  // =====================
  async function populateColorDropdown() {
    const colorSelect = document.getElementById('zentrum-color');
    const loadingDiv = document.getElementById('zentrum-color-loading');
    
    if (!colorSelect) return;
    
    if (loadingDiv) loadingDiv.style.display = 'block';
    
    const colors = await loadCenterColors();
    
    if (loadingDiv) loadingDiv.style.display = 'none';
    
    if (colors.length === 0) {
      console.warn('⚠️ No colors loaded, keeping empty dropdown');
      return;
    }
    
    const currentValue = colorSelect.value;
    
    colorSelect.innerHTML = `<option value="">-- ${T.labelZentrumColor_new} --</option>`;
    colors.forEach(color => {
      const option = document.createElement('option');
      option.value = color;
      option.textContent = color;
      colorSelect.appendChild(option);
    });
    
    if (currentValue && colors.includes(currentValue)) {
      colorSelect.value = currentValue;
    } else if (!currentValue && colors.length > 0) {
      colorSelect.value = colors[0];
    }
  }

  // =====================
  // Download templates from product
  // =====================
  async function loadCenterTemplates() {
    if (centerTemplatesCache) {
      console.log('✅ Using cached center templates');
      return centerTemplatesCache;
    }

    try {
      console.log('📥 Loading center templates from product...');
      const response = await fetch(`/products/${CENTER_TEMPLATES_PRODUCT_HANDLE}.js`);
      
      if (!response.ok) {
        throw new Error(`Failed to load product: ${response.status}`);
      }
      
      const product = await response.json();
      const templates = [];
      
      product.variants.forEach(variant => {
        if (variant.featured_image) {
          templates.push({
            id: variant.id,
            title: variant.title || variant.option1,
            imageUrl: variant.featured_image.src,
            variantId: variant.id
          });
        }
      });
      
      if (templates.length === 0 && product.images && product.images.length > 0) {
        product.images.forEach((img, index) => {
          templates.push({
            id: img.id,
            title: img.alt || `Template ${index + 1}`,
            imageUrl: img.src,
            variantId: null
          });
        });
      }
      
      centerTemplatesCache = templates;
      console.log('✅ Loaded center templates:', templates);
      return templates;
      
    } catch (error) {
      console.error('❌ Failed to load center templates:', error);
      return [];
    }
  }
  
  // =====================
  // Fill out the template gallery
  // =====================
  async function populateTemplatesGallery() {
    const gallery = document.getElementById('zentrum-templates-gallery');
    const loadingDiv = document.getElementById('zentrum-templates-loading');
    const hiddenInput = document.getElementById('selected-template-url');
    
    if (!gallery) return;
    
    if (loadingDiv) loadingDiv.style.display = 'block';
    
    const templates = await loadCenterTemplates();
    
    if (loadingDiv) loadingDiv.style.display = 'none';
    
    if (templates.length === 0) {
      gallery.innerHTML = '<p style="text-align:center;color:#999;padding:20px;">Keine Vorlagen verfügbar</p>';
      return;
    }
    
    const currentSelectedUrl = hiddenInput ? hiddenInput.value : '';
    
    gallery.innerHTML = '';
    templates.forEach(template => {
      const isSelected = currentSelectedUrl === template.imageUrl || currentImageUrl === template.imageUrl;
      
      const item = document.createElement('div');
      item.style.cssText = `
        cursor:pointer;
        border:3px solid ${isSelected ? '#910045' : '#ddd'};
        border-radius:6px;
        overflow:hidden;
        transition:all 0.3s;
        position:relative;
      `;
      
      item.innerHTML = `
        <img src="${template.imageUrl}" alt="${template.title}" 
          style="width:100%;height:120px;object-fit:contain;display:block;">
        <div style="padding:5px;text-align:center;font-size:11px;background:${isSelected ? '#910045' : '#f5f5f5'};color:${isSelected ? 'white' : '#333'};">
          ${template.title}
        </div>
        ${isSelected ? '<div style="position:absolute;top:5px;right:5px;background:#910045;color:white;border-radius:50%;width:24px;height:24px;display:flex;align-items:center;justify-content:center;font-weight:bold;">✓</div>' : ''}
      `;
      
      item.addEventListener('mouseenter', function() {
        if (!isSelected) {
          this.style.borderColor = '#910045';
          this.style.opacity = '0.8';
        }
      });
      
      item.addEventListener('mouseleave', function() {
        if (!isSelected) {
          this.style.borderColor = '#ddd';
          this.style.opacity = '1';
        }
      });
      
      item.addEventListener('click', function() {
        selectTemplate(template.imageUrl, template.title);
      });
      
      gallery.appendChild(item);
    });
  }

  // =====================
  // Select a template
  // =====================
  function selectTemplate(imageUrl, title) {
    const hiddenInput = document.getElementById('selected-template-url');
    if (hiddenInput) {
      hiddenInput.value = imageUrl;
    }
    
    currentImageUrl = imageUrl;
    currentImagePublicId = imageUrl;
    currentImageTitle = title;
    currentImageSource = 'template';
    
    updateImagePreview(imageUrl, title);
    populateTemplatesGallery();
    
    console.log('✅ Template selected:', title, '(URL:', imageUrl, ')');
  }

  window.selectTemplate = selectTemplate;

  // =====================
  // Public interface for external scripts (kb-cart-templates-*.js)
  // =====================
  window.kbCartIndividualisierung = {
    // Utilities
    matchOption,
    readProp,
    // Constants of the current language
    get T() { return T; },
    get LANG() { return LANG; },
    get PROPERTY_NAMES() { return PROPERTY_NAMES; },
    // Выбор шаблона из внешней галереи:
    // templateId  → записывается в #zentrum-template-no
    // fileUrl     → передаётся в selectTemplate() как imageUrl
    onTemplateSelect(templateId, fileUrl) {
      const hasTemplateId = templateId && templateId.trim() !== '';
      const hasFileUrl    = fileUrl    && fileUrl.trim()    !== '';

      const templateNoInput = document.getElementById('zentrum-template-no');
      if (templateNoInput) {
        templateNoInput.value = hasTemplateId ? templateId.trim() : '';
      }

      if (hasFileUrl) {
        selectTemplate(fileUrl.trim(), hasTemplateId ? templateId.trim() : fileUrl.trim());
      } else {
        currentImageUrl      = '';
        currentImagePublicId = '';
        currentImageTitle    = hasTemplateId ? templateId.trim() : '';
        currentImageSource   = '';
        updateImagePreview(null, null);
        populateTemplatesGallery();
      }
    }
  };

  // =====================
  // Utility functions
  // =====================
  function escapeSelector(str) {
    return str.replace(/[!"#$%&'()*+,.\/:;<=>?@[\\\]^`{|}~]/g, '\\$&');
  }

  /**
   * Парсит variant_title конфигурационного товара (SKU 100000).
   * Формат: "3 / VIP montiert / VIP plus (50 mm)"
   *          "1 / Fächer montiert / Kein VIP plus"
   */
  function _parseKonfiguratorVariant(variantTitle) {
    const parts = (variantTitle || '').split(' / ').map(p => p.trim());
    const bandCount = parseInt(parts[0]) || 1;
    const montage   = parts[1] || '';
    const vipPart   = parts[2] || '';
    const isVIP     = montage === T.montageVIP;
    const hasVipPlus = vipPart !== '' && vipPart !== T.vipPlusNone;
    const vipSize   = /VIP plus \(50 mm\)/i.test(vipPart) ? 'vip+50' : 'vip+';
    return { bandCount, isVIP, hasVipPlus, vipSize };
  }

  function checkProductTitle(title, sku) {
    if (sku && sku === T.konfigurator_sku) return true;
    if (!title) return false;
    const keywords = T.keywords || ["Schleife ", "Konfigurator"];
    return keywords.some(keyword => title.includes(keyword));
  }


  // =====================
  // Parsing produktionsbeschreibung from HTML
  // =====================
  function parseRibbonCountFromHTML(key) {
    try {
      const escapedKey = escapeSelector(key);
      const itemEl = document.querySelector(`#product-id-${escapedKey}`) 
                  || document.querySelector(`[data-product-id="${key}"]`);
      
      if (!itemEl) return null;

      const beschreibung = itemEl.querySelector('.produktionsbeschreibung') 
                        || itemEl.querySelector('.variants');
      
      if (!beschreibung) return null;

      const text = beschreibung.textContent || beschreibung.innerText;
      const parts = text.split('|').map(p => p.trim());
      
      let colorsString = '';
      const bandKeyword = T.bandKeyword || "Bänder";
      
      for (let i = 0; i < parts.length; i++) {
        const part = parts[i];
        if (part.toLowerCase().includes(bandKeyword.toLowerCase())) {
          if (i + 2 < parts.length) {
            colorsString = parts[i + 2];
            break;
          }
        }
      }

      if (!colorsString) {
        for (const part of parts) {
          if (/\d{2}-[a-zäöü]+/i.test(part) && part.includes(',')) {
            colorsString = part;
            break;
          }
        }
      }

      if (colorsString) {
        colorsString = colorsString.split(/Zentrum|Center|Centre/i)[0].trim();
        const colors = colorsString.split(',')
          .map(c => c.trim())
          .filter(c => c.length > 0 && /\d{2}-/.test(c));
        
        let count = colors.length;
        
        if (/VIP-plus/i.test(text)) {
          console.log(`✅ Found VIP-plus marker, adding +1 to count: ${count} → ${count + 1}`);
          count += 1;
        }
        
        if (count > 0) {
          console.log(`✅ Parsed ${count} ribbons from HTML`);
          return count;
        }
      }
    } catch (error) {
      console.error("Error parsing:", error);
    }
    
    return null;
  }

  // =====================
  //  Get the color of a specific tape
  // =====================
  function getBandColor(bandIndex, key) {
    const colors = parseRibbonColorsFromHTML(key);
    console.log(`🔍 getBandColor(${bandIndex}, ${key}):`, colors);
    console.log(`   → Returning colors[${bandIndex - 1}] =`, colors[bandIndex - 1]);
    return colors[bandIndex - 1] || '';
  }
  // =====================
  // Parsing ribbon colors from HTML
  // =====================
  function parseRibbonColorsFromHTML(key) {
  try {
    const escapedKey = escapeSelector(key);
    const itemEl = document.querySelector(`#product-id-${escapedKey}`) 
                || document.querySelector(`[data-product-id="${key}"]`);
    
    if (!itemEl) {
      console.log('❌ itemEl not found for key:', key);
      return [];
    }
 
    const itemDetails = itemEl.querySelector('.item-details');
    if (!itemDetails) {
      console.log('❌ itemDetails not found');
      return [];
    }
 
    // ✅ 1️⃣ PPLR конфигураторы: .property-item элементы
    const propertyItems = itemDetails.querySelectorAll('.property-item');
    const bandColors = [];
    let maxBandIndex = 0;
    
    if (propertyItems.length > 0) {
      console.log('📊 Using .property-item parsing (PPLR configurators)');
      
      const bandPatterns = [
        /^Band\s+(\d+)\s+von\s+\d+\s+\([^)]+\):?$/i,
        /^Cinta\s+(\d+)\s+de\s+\d+\s+\([^)]+\):?$/i,
        /^Ribbon\s+(\d+)\s+of\s+\d+\s+\([^)]+\):?$/i,
        /^Lint\s+(\d+)\s+van\s+\d+\s+\([^)]+\):?$/i,
        /^Bånd\s+(\d+)\s+af\s+\d+\s+\([^)]+\):?$/i,
      ];
      
      const vipPlusPatterns = [
        /^VIP\+?\s+Band\s+\([^)]+\):?$/i,
        /^VIP\+?\s+Cinta\s+\([^)]+\):?$/i,
        /^VIP\+?\s+Ribbon\s+\([^)]+\):?$/i,
        /^VIP\+?\s+Lint\s+\([^)]+\):?$/i,
        /^VIP\+?\s+Bånd\s+\([^)]+\):?$/i,
      ];
      
      propertyItems.forEach(item => {
        const nameEl = item.querySelector('.property-name');
        const valueEl = item.querySelector('.property-value');
        
        if (!nameEl || !valueEl) return;
        
        const name = nameEl.textContent.trim();
        const value = valueEl.textContent.trim();
        
        // Проверяем обычные ленты
        for (const pattern of bandPatterns) {
          const match = name.match(pattern);
          if (match) {
            const bandIndex = parseInt(match[1]);
            bandColors.push({ index: bandIndex, color: value });
            maxBandIndex = Math.max(maxBandIndex, bandIndex);
            console.log(`   ✅ Band ${bandIndex}: ${value}`);
            break;
          }
        }
        
        // Проверяем VIP+
        for (const pattern of vipPlusPatterns) {
          if (pattern.test(name)) {
            bandColors.push({ index: 999, color: value, isVipPlus: true });
            console.log(`   ✅ VIP+ Band: ${value}`);
            break;
          }
        }
      });
      
      if (bandColors.length > 0) {
        bandColors.forEach(item => {
          if (item.isVipPlus) {
            item.index = maxBandIndex + 1;
          }
        });
        
        bandColors.sort((a, b) => a.index - b.index);
        const colors = bandColors.map(b => b.color);
        console.log('🎨 Parsed ribbon colors (property-item):', colors);
        return colors;
      }
    }
    
    // ✅ 2️⃣ Fallback: produktionsbeschreibung с <br> тегами
    console.log('📋 Using <br> HTML parsing (produktionsbeschreibung)');
    
    const htmlContent = itemDetails.innerHTML;
    const lines = htmlContent.split(/<br\s*\/?>/i).map(line => {
      return line.replace(/<[^>]+>/g, '').trim();
    }).filter(line => line.length > 0);
    
    console.log('📋 Lines from HTML:', lines);
    
    const htmlBandColors = [];
    let htmlMaxBandIndex = 0;
    
    // Парсим "Bänder: ... | 01-gelb, 01-gelb |"
    for (const line of lines) {
      if (/^Bänder:|^Cintas:|^Ribbons:|^Linten:|^Bånd:/i.test(line)) {
        const parts = line.split('|');
        const colorPart = parts[parts.length - 2]; // Перед последней |
        
        if (colorPart) {
          const colors = colorPart.split(',').map(c => c.trim()).filter(c => c.length > 0);
          colors.forEach((color, idx) => {
            htmlBandColors.push({ 
              index: idx + 1, 
              color: color 
            });
            htmlMaxBandIndex = Math.max(htmlMaxBandIndex, idx + 1);
            console.log(`   ✅ Band ${idx + 1}: ${color}`);
          });
        }
        break;
      }
    }
    
    // Парсим VIP+ Band
    for (const line of lines) {
      const vipPlusPatterns = [
        /^VIP\+?\s+Band\s*\(.*?\):\s*(.+)$/i,
        /^VIP\+?\s+Cinta\s*\(.*?\):\s*(.+)$/i,
        /^VIP\+?\s+Ribbon\s*\(.*?\):\s*(.+)$/i,
        /^VIP\+?\s+Lint\s*\(.*?\):\s*(.+)$/i,
        /^VIP\+?\s+Bånd\s*\(.*?\):\s*(.+)$/i,
      ];
      
      for (const pattern of vipPlusPatterns) {
        const match = line.match(pattern);
        if (match) {
          const color = match[1] || '';
          htmlBandColors.push({ 
            index: htmlMaxBandIndex + 1, 
            color: color, 
            isVipPlus: true 
          });
          console.log(`   ✅ VIP+ Band: ${color}`);
          break;
        }
      }
    }
    
    if (htmlBandColors.length > 0) {
      htmlBandColors.sort((a, b) => a.index - b.index);
      const colors = htmlBandColors.map(b => b.color);
      console.log('🎨 Parsed ribbon colors (HTML <br>):', colors);
      return colors;
    }
    
    // ✅ 3️⃣ Fallback: produktionsbeschreibung БЕЗ <br> (текст в одну строку)
    console.log('📋 Using text parsing (no <br> tags)');
    
    const rawText = itemDetails.textContent || itemDetails.innerText;
    console.log('📋 Raw text:', rawText.substring(0, 200) + '...');
    
    const textBandColors = [];
    let textMaxBandIndex = 0;
    
    // Парсим "Bänder: ... | 01-gelb, 01-gelb |"
    const banderMatch = rawText.match(/Bänder:.*?\|\s*([^|]+)\s*\|/i);
    if (banderMatch) {
      const colorsPart = banderMatch[1];
      const colors = colorsPart.split(',').map(c => c.trim()).filter(c => c.length > 0);
      
      colors.forEach((color, idx) => {
        textBandColors.push({ index: idx + 1, color: color });
        textMaxBandIndex = Math.max(textMaxBandIndex, idx + 1);
        console.log(`   ✅ Band ${idx + 1}: ${color}`);
      });
    }
    
    // Парсим VIP+ (формат: "VIP+ Band (25 mm): цвет" или "VIP+ Band (50 mm): цвет")
    const vipMatch = rawText.match(/VIP\+?\s+Band\s*\([^)]*\):\s*([^\n\r|]+)/i);
    if (vipMatch) {
      const vipColor = vipMatch[1].trim();
      textBandColors.push({ 
        index: textMaxBandIndex + 1, 
        color: vipColor,
        isVipPlus: true 
      });
      console.log(`   ✅ VIP+ Band: ${vipColor}`);
    }
    
    if (textBandColors.length > 0) {
      textBandColors.sort((a, b) => a.index - b.index);
      const colors = textBandColors.map(b => b.color);
      console.log('🎨 Parsed ribbon colors (text no <br>):', colors);
      return colors;
    }
    
    console.log('⚠️ No ribbon colors found in any format');
    
  } catch (error) {
    console.error("❌ Error parsing ribbon colors:", error);
  }
  
  return [];
}
  /*
  function parseRibbonColorsFromHTML(key) {
    try {
      const escapedKey = escapeSelector(key);
      const itemEl = document.querySelector(`#product-id-${escapedKey}`) 
                  || document.querySelector(`[data-product-id="${key}"]`);
      
      if (!itemEl) return [];

      const itemDetails = itemEl.querySelector('.item-details');
      if (!itemDetails) return [];

      const propertyItems = itemDetails.querySelectorAll('.property-item');
      const bandColors = [];
      
      // Паттерны для обычных лент
      const bandPatterns = [
        /^Band\s+(\d+)\s+von\s+\d+\s+\([^)]+\):?$/i,      // DE
        /^Cinta\s+(\d+)\s+de\s+\d+\s+\([^)]+\):?$/i,      // ES
        /^Ribbon\s+(\d+)\s+of\s+\d+\s+\([^)]+\):?$/i,     // EN
        /^Lint\s+(\d+)\s+van\s+\d+\s+\([^)]+\):?$/i,      // NL
        /^Bånd\s+(\d+)\s+af\s+\d+\s+\([^)]+\):?$/i,       // DK
      ];
      
      // ✅ Паттерн для VIP+
      const vipPlusPatterns = [
        /^VIP\+?\s+Band\s+\([^)]+\):?$/i,                  // DE: "VIP+ Band (25 x 250 mm):"
        /^VIP\+?\s+Cinta\s+\([^)]+\):?$/i,                 // ES
        /^VIP\+?\s+Ribbon\s+\([^)]+\):?$/i,                // EN
        /^VIP\+?\s+Lint\s+\([^)]+\):?$/i,                  // NL
        /^VIP\+?\s+Bånd\s+\([^)]+\):?$/i,                  // DK
      ];
      
      let maxBandIndex = 0;
      
      propertyItems.forEach(item => {
        const nameEl = item.querySelector('.property-name');
        const valueEl = item.querySelector('.property-value');
        
        if (!nameEl || !valueEl) return;
        
        const name = nameEl.textContent.trim();
        const value = valueEl.textContent.trim();
        
        // Проверяем обычные ленты
        for (const pattern of bandPatterns) {
          const match = name.match(pattern);
          if (match) {
            const bandIndex = parseInt(match[1]);
            bandColors.push({ index: bandIndex, color: value });
            maxBandIndex = Math.max(maxBandIndex, bandIndex);
            break;
          }
        }
        
        // ✅ Проверяем VIP+
        for (const pattern of vipPlusPatterns) {
          if (pattern.test(name)) {
            // VIP+ всегда последняя лента
            bandColors.push({ index: 999, color: value, isVipPlus: true });
            break;
          }
        }
      });
      
      if (bandColors.length > 0) {
        // ✅ Переназначаем индекс VIP+ как последний ДО сортировки
        bandColors.forEach(item => {
          if (item.isVipPlus) {
            item.index = maxBandIndex + 1;
          }
        });
        
        // ✅ Сортируем ОДИН раз
        bandColors.sort((a, b) => a.index - b.index);
        
        const colors = bandColors.map(b => b.color);
        console.log('🎨 Parsed ribbon colors (from property-item elements):', colors);
        return colors;
      }
      
      // ✅ Fallback: текстовый парсинг для produktionsbeschreibung
      const text = itemDetails.textContent || itemDetails.innerText;
      const parts = text.split('|').map(p => p.trim());
      
      let colorsString = '';
      const bandKeyword = T.bandKeyword || "Bänder";
      
      for (let i = 0; i < parts.length; i++) {
        const part = parts[i];
        if (part.toLowerCase().includes(bandKeyword.toLowerCase())) {
          if (i + 2 < parts.length) {
            colorsString = parts[i + 2];
            break;
          }
        }
      }

      if (!colorsString) {
        for (const part of parts) {
          if (/\d{2}-[a-zäöü]+/i.test(part) && part.includes(',')) {
            colorsString = part;
            break;
          }
        }
      }

      if (colorsString) {
        colorsString = colorsString.split(/Zentrum|Center|Centre/i)[0].trim();
        
        const colors = colorsString.split(',')
          .map(c => c.trim())
          .filter(c => c.length > 0);
        
        console.log('🎨 Parsed ribbon colors (produktionsbeschreibung format):', colors);
        return colors;
      }
    } catch (error) {
      console.error("❌ Error parsing ribbon colors:", error);
    }
    
    return [];
  }
  */  
  // =====================
  //  Checking tape blocking (metallic, glitter, etc.)
  // =====================
  function isBandColorBlocked(ribbonColorString) {
    if (!ribbonColorString) return { blocked: false, reason: '' };
    
    // Blocking Patterns (Multilingual)
    const blockedPatterns = {
      de: [
        { pattern: /metallic/i, label: 'Metallic' },
        { pattern: /glitter/i, label: 'Glitter' },
        { pattern: /mit pünktchen/i, label: 'mit Pünktchen' },
        { pattern: /gepunktet/i, label: 'gepunktet' }
      ],
      en: [
        { pattern: /metallic/i, label: 'Metallic' },
        { pattern: /glitter/i, label: 'Glitter' },
        { pattern: /with dots/i, label: 'with dots' },
        { pattern: /dotted/i, label: 'dotted' }
      ],
      es: [
        { pattern: /metallic/i, label: 'Metálico' },
        { pattern: /glitter/i, label: 'Glitter' },
        { pattern: /con puntos/i, label: 'con puntos' },
        { pattern: /punteado/i, label: 'punteado' }
      ],
      nl: [
        { pattern: /metallic/i, label: 'Metallic' },
        { pattern: /glitter/i, label: 'Glitter' },
        { pattern: /met stippen/i, label: 'met stippen' },
        { pattern: /gestippeld/i, label: 'gestippeld' }
      ],
      dk: [
        { pattern: /metallic/i, label: 'Metallic' },
        { pattern: /glitter/i, label: 'Glitter' },
        { pattern: /med prikker/i, label: 'med prikker' },
        { pattern: /prikket/i, label: 'prikket' }
      ]
    };
    
    const patterns = blockedPatterns[LANG] || blockedPatterns.de;
    
    for (const item of patterns) {
      if (item.pattern.test(ribbonColorString)) {
        return { 
          blocked: true, 
          reason: item.label 
        };
      }
    }
    
    return { blocked: false, reason: '' };
  }

  // =====================
  //  Get the color of a specific tape
  // =====================
  function getBandColor(bandIndex, key) {
    const colors = parseRibbonColorsFromHTML(key);
    // bandIndex starts at 1, array at 0
    return colors[bandIndex - 1] || '';
  }  

  // =====================
  // Determine feed type from HTML - VIP+ ONLY
  // =====================
  function determineBandTypeFromHTML_VipPlusOnly(bandIndex, key) {
    try {
      const escapedKey = escapeSelector(key);
      const itemEl = document.querySelector(`#product-id-${escapedKey}`) 
                  || document.querySelector(`[data-product-id="${key}"]`);
      
      if (!itemEl) return null;

      const beschreibung = itemEl.querySelector('.produktionsbeschreibung') 
                        || itemEl.querySelector('.variants');
      
      if (!beschreibung) return null;

      const text = beschreibung.textContent || beschreibung.innerText;
      
      if (!/VIP-plus/i.test(text)) return null;
      
      const parts = text.split('|').map(p => p.trim());
      let colorsString = '';
      const bandKeyword = T.bandKeyword || "Bänder";
      
      for (let i = 0; i < parts.length; i++) {
        const part = parts[i];
        if (part.toLowerCase().includes(bandKeyword.toLowerCase())) {
          if (i + 2 < parts.length) {
            colorsString = parts[i + 2];
            break;
          }
        }
      }
      
      if (!colorsString) {
        for (const part of parts) {
          if (/\d{2}-[a-zäöü]+/i.test(part) && part.includes(',')) {
            colorsString = part;
            break;
          }
        }
      }
      
      if (colorsString) {
        colorsString = colorsString.split(/Zentrum|Center|Centre/i)[0].trim();
        const colors = colorsString.split(',')
          .map(c => c.trim())
          .filter(c => c.length > 0 && /\d{2}-/.test(c));
        
        if (bandIndex === colors.length + 1) {
          console.log(`✅ Band ${bandIndex} is VIP+ (from HTML VIP-plus marker)`);
          return 'vip+';
        }
      }
      
      return null;
      
    } catch (error) {
      console.error("❌ Error determining VIP+ from HTML:", error);
    }
    
    return null;
  }
  //VIP plus 25 or 50mm
  function getVipPlusSize(key) {
    // Konfi размер VIP+ -variant_title
    if (currentItemData.sku === T.konfigurator_sku) {
      return _parseKonfiguratorVariant(currentItemData.variant_title || '').vipSize;
    }
    
    // ✅ DOM (.item-details)
    try {
      const escapedKey = escapeSelector(key);
      const itemEl = document.querySelector(`#product-id-${escapedKey}`)
                  || document.querySelector(`[data-product-id="${key}"]`);

      if (itemEl) {
        // Ищем в разных местах
        const beschreibung = itemEl.querySelector('.item-details')
                          || itemEl.querySelector('.produktionsbeschreibung')
                          || itemEl.querySelector('.variants');
        
        if (beschreibung) {
          const text = beschreibung.textContent || beschreibung.innerText;
          
          // ✅ VIP+ or VIP plus
          if (/VIP\s*\+\s*(?:Band|Cinta|Ribbon|Lint|Bånd).*?\(50\s*mm\)/i.test(text)) return 'vip+50';
          if (/VIP plus \(50 mm\)/i.test(text)) return 'vip+50';
          
          if (/VIP\s*\+\s*(?:Band|Cinta|Ribbon|Lint|Bånd).*?\(25\s*mm\)/i.test(text)) return 'vip+';
          if (/VIP plus \(25 mm\)/i.test(text)) return 'vip+';
          
          // Fallback: просто VIP+
          if (/VIP\s*\+|VIP\s*plus/i.test(text)) return 'vip+';
        }
      }
    } catch (e) {
      console.error('Error in getVipPlusSize:', e);
    }

    // ✅ Fallback — properties
    const props = currentItemData.properties || {};
    for (const propKey of Object.keys(props)) {
      if (/VIP plus \(50 mm\)/i.test(propKey)) return 'vip+50';
      if (/VIP\+.*50\s*mm/i.test(propKey)) return 'vip+50';
      if (/^VIP plus$/i.test(propKey))  return 'vip+';
      if (/^VIP\+$/i.test(propKey))     return 'vip+';
    }

    return 'vip+';
  }
  // =====================
  // Determine the number of ribbons
  // =====================
  async function determineRibbonCount(item, key) {
    console.log('determineRibbonCount: sku=', item.sku, 'konfigurator_sku=', T.konfigurator_sku);
    
    // ✅ SKU 1000000: количество из variant_title
    if (item.sku === T.konfigurator_sku) {
      const parsed = _parseKonfiguratorVariant(item.variant_title || '');
      const count = parsed.bandCount + (parsed.hasVipPlus ? 1 : 0);
      console.log(`✅ Konfigurator SKU 1000000: ${parsed.bandCount} Bänder + VIP+: ${parsed.hasVipPlus} → total: ${count}`);
      return count;
    }

    // ✅ PPLR Konfigurator: ищем "Anzahl der Bänder: 3" в DOM
    const escapedKey = escapeSelector(key);
    const itemEl = document.querySelector(`#product-id-${escapedKey}`) 
                || document.querySelector(`[data-product-id="${key}"]`);
    
    if (itemEl) {
      const itemDetails = itemEl.querySelector('.item-details');
      if (itemDetails) {
        const propertyItems = itemDetails.querySelectorAll('.property-item');
        
        let bandCount = 0;
        let hasVipPlus = false;
        
        for (const item of propertyItems) {
          const nameEl = item.querySelector('.property-name');
          const valueEl = item.querySelector('.property-value');
          
          if (nameEl && valueEl) {
            const name = nameEl.textContent.trim();
            const value = valueEl.textContent.trim();
            
            // ✅ Проверяем "Anzahl der Bänder: X"
            if (name.includes(T.bandCountKey)) {
              const match = value.match(/(\d+)/);
              if (match) {
                bandCount = parseInt(match[1]);
              }
            }
            
            // ✅ Проверяем наличие VIP+
            if (/VIP\+?\s+(Band|Cinta|Ribbon|Lint|Bånd)/i.test(name)) {
              hasVipPlus = true;
            }
          }
        }
        
        if (bandCount > 0) {
          const total = bandCount + (hasVipPlus ? 1 : 0);
          console.log(`✅ Found "${T.bandCountKey}: ${bandCount}" + VIP+: ${hasVipPlus} → total: ${total}`);
          return total;
        }
      }
    }

    // ✅ Fallback: produktionsbeschreibung парсинг
    const htmlCount = parseRibbonCountFromHTML(key);
    if (htmlCount && htmlCount > 0) {
      console.log(`✅ Using htmlCount from produktionsbeschreibung: ${htmlCount}`);
      return htmlCount;
    }
    
    // ✅ Fallback: подсчёт по properties
    if (item.properties) {
      const P = PROPERTY_NAMES[LANG] || PROPERTY_NAMES.de;
      let maxBandNumber = 0;
      
      Object.keys(item.properties).forEach(propKey => {
        const match = propKey.match(new RegExp(`${P.band}\\s+(\\d+)`));
        if (match) {
          const num = parseInt(match[1]);
          if (num > maxBandNumber) maxBandNumber = num;
        }
      });
      
      if (maxBandNumber > 0) {
        let count = maxBandNumber;
        
        if (hasVipPlusBand(item.properties)) {
          console.log(`✅ Found VIP+ band in properties, adding +1: ${count} → ${count + 1}`);
          count += 1;
        }
        
        console.log(`✅ Using count from properties: ${count}`);
        return count;
      }
    }
    
    console.log('⚠️ No ribbon count found, using default: 3');
    return 3; // default
  }

  // =====================
  // Determine the tape type (VIP/VIP+/regular)
  // =====================
  function determineBandType(bandIndex, properties, key) {
    // Конфигурационный товар: тип ленты из variant_title
    if (currentItemData.sku === T.konfigurator_sku) {
      const parsed = _parseKonfiguratorVariant(currentItemData.variant_title || '');
      const isLastBand = bandIndex === ribbonCount;
      if (isLastBand && parsed.hasVipPlus) return 'vip+';
      if (parsed.isVIP) {
        if (parsed.bandCount === 1 && parsed.hasVipPlus) {
          if (bandIndex === 1) return 'vip';
        } else if (parsed.bandCount >= 3) {
          const vipIndex = Math.ceil((parsed.bandCount - 1) / 2) + 1;
          if (bandIndex === vipIndex) return 'vip';
        }
      }
      return 'normal';
    }

    if (key) {
      const vipPlusCheck = determineBandTypeFromHTML_VipPlusOnly(bandIndex, key);
      if (vipPlusCheck === 'vip+') {
        return 'vip+';
      }
    }
    
    if (!properties) return 'normal';
    
    const bandPatterns = [
      new RegExp(`^Band\\s+${bandIndex}\\s+von\\s+\\d+`, 'i'),
      new RegExp(`^Cinta\\s+${bandIndex}\\s+de\\s+\\d+`, 'i'),
      new RegExp(`^Ribbon\\s+${bandIndex}\\s+of\\s+\\d+`, 'i'),
      new RegExp(`^Lint\\s+${bandIndex}\\s+van\\s+\\d+`, 'i'),
      new RegExp(`^Bånd\\s+${bandIndex}\\s+af\\s+\\d+`, 'i'),
    ];
    
    const textPatterns = [
      new RegExp(`^_Text auf Band\\s+${bandIndex}\\s+von\\s+\\d+`, 'i'),
      new RegExp(`^_Texto en el cinta\\s+${bandIndex}\\s+de\\s+\\d+`, 'i'),
      new RegExp(`^_Text on ribbon\\s+${bandIndex}\\s+of\\s+\\d+`, 'i'),
      new RegExp(`^_Tekst op lint\\s+${bandIndex}\\s+van\\s+\\d+`, 'i'),
      new RegExp(`^_Tekst på bånd\\s+${bandIndex}\\s+af\\s+\\d+`, 'i'),
    ];
    
    const isLastBand = (bandIndex === ribbonCount);
    
    if (isLastBand) {
      const vipPlusPatterns = [
        /^VIP\+\s+cinta/i,
        /^VIP\+\s+Band/i,
        /^VIP\+\s+ribbon/i,
        /^VIP\+\s+lint/i,
        /^VIP\+\s+bånd/i,
        /^_Texto en el cinta VIP\+$/i,
        /^_Text auf Band VIP\+$/i,
        /^_Text on ribbon VIP\+$/i,
        /^_Tekst op lint VIP\+$/i,
        /^_Tekst på bånd VIP\+$/i,
      ];
      
      for (const propKey of Object.keys(properties)) {
        for (const pattern of vipPlusPatterns) {
          if (pattern.test(propKey)) {
            console.log(`✅ Band ${bandIndex} is VIP+ (from VIP+ property: ${propKey})`);
            return 'vip+';
          }
        }
      }
    }
    
    for (const propKey of Object.keys(properties)) {
      for (const pattern of bandPatterns) {
        if (pattern.test(propKey)) {
          if (/VIP\+/i.test(propKey)) {
            console.log(`✅ Band ${bandIndex} is VIP+ (from properties: ${propKey})`);
            return 'vip+';
          }
          if (/VIP montiert|montado VIP|VIP mounted/i.test(propKey)) {
            console.log(`✅ Band ${bandIndex} is VIP (from properties: ${propKey})`);
            return 'vip';
          }
          console.log(`✅ Band ${bandIndex} is normal (from properties: ${propKey})`);
          return 'normal';
        }
      }
      
      for (const pattern of textPatterns) {
        if (pattern.test(propKey)) {
          if (/\(VIP\+\)/i.test(propKey)) {
            console.log(`✅ Band ${bandIndex} is VIP+ (from tech key: ${propKey})`);
            return 'vip+';
          }
          if (/\(VIP\)/i.test(propKey)) {
            console.log(`✅ Band ${bandIndex} is VIP (from tech key: ${propKey})`);
            return 'vip';
          }
          return 'normal';
        }
      }
    }
    
    return 'normal';
  }

  // =====================
  // Is there a VIP+ feed?
  // =====================
  function hasVipPlusBand(properties) {
    if (!properties) return false;
    
    for (const key of Object.keys(properties)) {
      if (/VIP\+|VIP plus/i.test(key)) {
        return true;
      }
    }
    
    return false;
  }

  // =====================
  // Parsing existing texts from properties
  // =====================
  function parseBandTextsFromProperties(bandIndex, properties, key) {
    const P = PROPERTY_NAMES[LANG] || PROPERTY_NAMES.de;
    const texts = [];
    
    const bandType = determineBandType(bandIndex, properties, key);

    let possibleKeys = [];
    if (bandType === 'vip+') {
      possibleKeys = [`${P.band} VIP+`];
    } else if (bandType === 'vip') {
      possibleKeys = [`${P.band} ${bandIndex} (VIP)`, `${P.band} ${bandIndex}`];
    } else {
      possibleKeys = [`${P.band} ${bandIndex}`];
    }
    
    const detailsKey = `${P.bandDetails} ${bandIndex}`;
    if (properties[detailsKey]) {
      try {
        const parsed = JSON.parse(properties[detailsKey]);
        return parsed.map((item, idx) => ({
          id: Date.now() + idx,
          value: item.text || item.value || '',
          original: item.text || item.value || '',
          quantity: item.qty || item.quantity || 1,
          enabled: true,
          isOverLimit: false
        }));
      } catch (e) {
        console.warn('Failed to parse band details JSON:', e);
      }
    }
    
    for (const baseKey of possibleKeys) {
      if (properties[baseKey]) {
        texts.push({
          id: Date.now(),
          value: properties[baseKey].trim(),
          original: properties[baseKey].trim(),
          quantity: 1,
          enabled: true,
          isOverLimit: false
        });
        return texts;
      }
      
      for (let subIndex = 1; subIndex <= 100; subIndex++) {
        const key = `${baseKey}.${subIndex}.`;
        const value = properties[key];
        
        if (!value) break;
        
        const match = value.match(/^(.+?)\s*\([\s×xX]*(\d+)[\s×xX]*.*?\)$/);
        
        if (match) {
          texts.push({
            id: Date.now() + subIndex,
            value: match[1].trim(),
            original: match[1].trim(),
            quantity: parseInt(match[2]) || 1,
            enabled: true,
            isOverLimit: false
          });
        } else {
          texts.push({
            id: Date.now() + subIndex,
            value: value.trim(),
            original: value.trim(),
            quantity: 1,
            enabled: true,
            isOverLimit: false
          });
        }
      }
      
      if (texts.length > 0) return texts;
    }
    
    Object.keys(properties).forEach(propKey => {
      if (propKey.startsWith('_')) return;
      
      for (const langCode in PROPERTY_NAMES) {
        const langProps = PROPERTY_NAMES[langCode];
        const escapedBand = langProps.band.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
        
        const pattern = new RegExp(
          `${escapedBand}\\s+(?:VIP\\s+)?(?:VIP\\+\\s+)?(\\d+)(?:\\s+(?:von|de|of|van|af)\\s+\\d+)?`,
          'i'
        );
        
        const match = propKey.match(pattern);
        
        if (match) {
          const foundBandIndex = parseInt(match[1]);
          
          if (foundBandIndex === bandIndex && properties[propKey]) {
            if (/ohne text|sin texto|no text|geen tekst|ingen tekst/i.test(properties[propKey])) {
              return;
            }
            
            console.log(`✅ Found text for band ${bandIndex} (${langCode}):`, properties[propKey]);
            texts.push({
              id: Date.now() + texts.length,
              value: properties[propKey].trim(),
              original: properties[propKey].trim(),
              quantity: 1,
              enabled: true,
              isOverLimit: false
            });
            return;
          }
        }
      }
    });
    
    return texts;
  }


  // =====================
  // Create fields for feeds dynamically
  // =====================
  function createRibbonFields(count, key) {
    console.log(`🎨 createRibbonFields called with count=${count}, key=${key}`);
    const container = document.getElementById("individ-fields-container");
    if (!container) return;
    const props = currentItemData.properties || {};
    const vipSize = getVipPlusSize(key);
    let html = '';
    bandTexts = {};
    const textDisabled = isTextDisabled();
for (let i = 1; textDisabled ? false : i <= count; i++) {
  const bandType = determineBandType(i, props, key);

  // ✅ Проверяем блокировку по цвету
  const bandColor = getBandColor(i, key);
  const blockInfo = isBandColorBlocked(bandColor);

  // ✅ VIP plus limits
  const isVipPlus = bandType === 'vip+';
  const cfg = isVipPlus
    ? (vipSize === 'vip+50' ? VIP_PLUS_50_CONFIG : VIP_PLUS_CONFIG)
    : { maxLines: EXCEL_CONFIG.maxLines, maxLineLength: EXCEL_CONFIG.maxLineLength };

  const placeholderText = isVipPlus
    ? Array.from({length: cfg.maxLines}, (_, j) =>
        `${T.charCounter} ${j+1} (max ${cfg.maxLineLength})`
      ).join('&#10;')
    : `${T.placeholderLine1}&#10;${T.placeholderLine2}`;

  let fieldLabel = '';
  const isKonfigurator = currentItemData.sku === T.konfigurator_sku;
  const konfigParsed = isKonfigurator ? _parseKonfiguratorVariant(currentItemData.variant_title || '') : null;
  const showIndex = ribbonCount > 1 && !(isKonfigurator && konfigParsed.bandCount === 1);
  
  if (bandType === 'vip+') {
    fieldLabel = `${T.labelBand} VIP+`;
  } else if (bandType === 'vip') {
    fieldLabel = showIndex ? `${T.labelBand} ${i} (VIP)` : `${T.labelBand} (VIP)`;
  } else {
    fieldLabel = showIndex ? `${T.labelBand} ${i}` : T.labelBand;
  }
  
  // ✅ Добавляем информацию о цвете если есть
  if (bandColor) {
    fieldLabel += ` <span style="color:#666;font-weight:normal;font-size:12px;">(${bandColor})</span>`;
  }

  // ✅ НОВОЕ: Если заблокирована — показываем только предупреждение
  if (blockInfo.blocked) {
    html += `
      <div style="border:1px solid #ffc107;padding:15px;border-radius:6px;background:#fff3cd;">
        <div style="display:flex;justify-content:space-between;align-items:center;">
          <strong style="margin:0;color:#856404;">
            ${fieldLabel}
          </strong>
        </div>
        <div style="margin-top:10px;color:#856404;">
          ⚠️ ${T.ribbonBlocked} (${blockInfo.reason})
        </div>
      </div>
    `;
  } else {
    // ✅ Обычное поле (не заблокировано)
    html += `
      <div style="border:1px solid #ddd;padding:15px;border-radius:6px;background:#f9f9f9;">
        <div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:10px;">
          <label style="font-weight:bold;margin:0;">
            ${fieldLabel}
          </label>
          <div style="display:flex;gap:5px;">
            <button type="button" class="btn-upload-excel" data-band="${i}" 
              style="padding:6px 12px;background:#4CAF50;color:white;border:none;border-radius:0px;cursor:pointer;font-size:12px;font-weight:bold;">
              ${T.btnUploadExcel}
            </button>
            <input type="file" id="excel-input-${i}" accept=".xlsx,.xls,.csv" style="display:none;">
          </div>
        </div>
        
        <textarea id="band${i}" class="individ-input band-input" 
          data-band="${i}"
          data-band-type="${bandType}"
          data-max-lines="${cfg.maxLines}"
          data-max-length="${cfg.maxLineLength}"
          data-vip-size="${isVipPlus ? vipSize : ''}"
          rows="${cfg.maxLines}"
          style="width:100%;padding:10px;border:1px solid #ccc;border-radius:0px;font-size:14px;margin-bottom:10px;resize:none;font-family:inherit;line-height:1.4;"
          placeholder="${placeholderText}"></textarea>

        <div id="band${i}-counter" style="font-size:11px;color:#666;margin-top:5px;text-align:right;">
          ${Array.from({length: cfg.maxLines}, (_, j) =>
            `<small>${T.charCounter} ${j+1}: 0/${cfg.maxLineLength}</small>`
          ).join(' | ')}
        </div>
        
        <div id="band${i}-preview" style="display:none;margin-top:10px;">
          <div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:5px;">
            <small style="font-weight:bold;color:#666;">${T.msgUploaded.replace('{count}', '0')}</small>
            <button type="button" onclick="deleteAllBandTexts(${i})" 
              style="padding:5px 12px;background:#f44336;color:white;border:none;border-radius:3px;cursor:pointer;font-size:12px;font-weight:bold;">
              ${T.deleteSelected}
            </button>
          </div>
          <div id="band${i}-list" style="max-height:200px;overflow-y:auto;border:1px solid #ddd;border-radius:0px;background:white;padding:5px;">
            <!-- Список текстов -->
          </div>
        </div>
      </div>
    `;
  }
}

    // Zentrumstyp — Using a new label
    html += `
      <div>
        <label style="font-weight:bold;display:block;margin-bottom:5px;">${T.labelZentrum_new}</label>
        <select id="zentrumstyp" class="individ-input" style="width:100%;padding:10px;border:1px solid #ccc;border-radius:0px;font-size:14px;">
          <option value="${T.optionBlank_new}">${T.optionBlank_new}</option>
          <option value="${T.optionStandard_new}">${T.optionStandard_new}</option>
          <option value="${T.optionFoil_new}">${T.optionFoil_new}</option>
          <option value="${T.optionDigital_new}">${T.optionDigital_new}</option>
        </select>
      </div>
    `;

    // Zentrum Color — Using the new label
    html += `
      <div id="zentrum-color-container" style="display:none;">
        <label style="font-weight:bold;display:block;margin-bottom:5px;">${T.labelZentrumColor_new}</label>
        <select id="zentrum-color" class="individ-input" 
          style="width:100%;padding:10px;border:1px solid #ccc;border-radius:0px;font-size:14px;">
          <option value="">-- ${T.labelZentrumColor_new} --</option>
        </select>
        <div id="zentrum-color-loading" style="display:none;margin-top:10px;text-align:center;color:#666;">
          <small>Lädt Farben...</small>
        </div>
      </div>
    `;

    html += `
      <div id="zentrum-templates-container" style="display:none;">
        <label style="font-weight:bold;display:block;margin-bottom:10px;">${T.labelTemplates}</label>
        <div id="zentrum-templates-loading" style="display:none;text-align:center;color:#666;padding:20px;">
          <small>Lädt Vorlagen...</small>
        </div>
        <div id="zentrum-templates-gallery" style="display:grid;grid-template-columns:repeat(auto-fill,minmax(120px,1fr));gap:10px;max-height:300px;overflow-y:auto;">
        </div>
        <input type="hidden" id="selected-template-url" value="">
      </div>
    `;

    // ✅ Material - Using the new label label (centerMaterial_new)
    html += `
      <div id="zentrum-material-container" style="display:none;">
        <label style="font-weight:bold;display:block;margin-bottom:5px;">${T.centerMaterial_new}</label>
        <select id="zentrum-material" class="individ-input" 
          style="width:100%;padding:10px;border:1px solid #ccc;border-radius:0px;font-size:14px;">
          <option value="${T.materialMetall_new}">${T.materialMetall_new}</option>
          <option value="${T.materialPlastic}">${T.materialPlastic}</option>
        </select>
      </div>
    `;
    
    html += `
      <div id="upload-container" style="display:none;">
          <!-- Gallery 1 -->
          <div id="kb-gallery-cart-templates"></div>
          <!-- Gallery 2 -->
          <div id="kb-gallery-customer-templates"></div>
          <!-- Template art. No -->
          <div style="margin-bottom:15px;">
            <label style="font-weight:bold;display:block;margin-bottom:5px;">
              ${T.labelTemplateNo}
            </label>
            <input type="text" id="zentrum-template-no" 
              style="width:100%;padding:10px;border:1px solid #ccc;border-radius:0px;font-size:14px;"
              placeholder="${T.labelTemplateNo}">
          </div>
          <!-- OR separator -->
          <div style="text-align:center;margin:10px 0;color:#999;font-size:13px;position:relative;">
            <span style="background:#fff;padding:0 10px;position:relative;color:#910045;font-weight:bold;z-index:1;">${T.labelOR}</span>
            <div style="position:absolute;top:50%;left:0;right:0;height:1px;background:#ddd;z-index:0;"></div>
          </div>

        <button type="button" id="cloudinary-upload-btn" 
          style="width:100%;padding:14px;background:#3448C5;color:white;border:none;border-radius:6px;cursor:pointer;font-weight:bold;font-size:15px;margin-bottom:15px;box-shadow:0 2px 4px rgba(52,72,197,0.3);">
          ${T.labelUploadCloudinary}
        </button>
        
        ${T.image_load_hint ? `
        <div style="
          display:inline-block;
          gap:12px;
          padding:16px 20px;
          margin:20px 0;
          background:#fff6dc;
          border:1px solid #f0e1b0;
          border-radius:0px;
          font-size:14px;
          width:100%;
          box-sizing:border-box;
          text-align:center;
        ">
          <div style="font-size:20px;line-height:1;margin-bottom:8px;">✨</div>
          <div>${T.image_load_hint.replace(/\n/g, '<br>')}</div>
        </div>` : ''}

        <div id="image-preview-container"></div>
      </div>
    `;

    container.innerHTML = html;

    setupExcelButtons();
    setupZentrumTypeHandlers();
    setupCloudinaryButton();
    setupBandInputHandlers();
  }


  // =====================
  // Handlers for feed input fields
  // =====================
  function setupBandInputHandlers() {
    document.querySelectorAll('.band-input').forEach(textarea => {
      textarea.addEventListener('input', () => {
        validateBandText(textarea);
        updateTotalQuantity();
      });
      
      textarea.addEventListener('paste', (e) => {
        e.preventDefault();
        const maxLines  = parseInt(textarea.dataset.maxLines)  || EXCEL_CONFIG.maxLines;
        const maxLength = parseInt(textarea.dataset.maxLength) || EXCEL_CONFIG.maxLineLength;
        
        const pastedText = (e.clipboardData || window.clipboardData).getData('text');
        const lines = pastedText.split('\n').slice(0, maxLines);
        const limitedLines = lines.map(line => line.substring(0, maxLength));
        
        document.execCommand('insertText', false, limitedLines.join('\n'));
        validateBandText(textarea);
      });
      
      textarea.addEventListener('keydown', (e) => {
        if (e.key === 'Enter') {
          const maxLines = parseInt(textarea.dataset.maxLines) || EXCEL_CONFIG.maxLines;
          const lines = textarea.value.split('\n');
          if (lines.length >= maxLines) {
            e.preventDefault();
          }
        }
      });
      
      updateCharCounter(textarea);
    });
  }


  // =====================
  // Setting up the Cloudinary button
  // =====================
  function setupCloudinaryButton() {
    const btn = document.getElementById('cloudinary-upload-btn');
    if (!btn) return;

    btn.addEventListener('click', function() {
      const widget = initCloudinaryWidget();
      if (widget) {
        widget.open();
      }
    });
  }


  // =====================
  // Customizing Excel Buttons
  // =====================
  function setupExcelButtons() {
    document.querySelectorAll('.btn-upload-excel').forEach(btn => {
      btn.addEventListener('click', function() {
        const bandIndex = parseInt(this.dataset.band);
        document.getElementById(`excel-input-${bandIndex}`).click();
      });
    });

    for (let i = 1; i <= ribbonCount; i++) {
      const input = document.getElementById(`excel-input-${i}`);
      if (input) {
        input.addEventListener('change', function(e) {
          if (e.target.files.length > 0) {
            processExcelForBand(e.target.files[0], i);
          }
        });
      }
    }
  }

  // =====================
  // Refresh the state of Excel buttons
  // =====================
  function updateExcelButtonsState() {
    let bandWithMultipleTexts = null;
    
    for (let i = 1; i <= ribbonCount; i++) {
      const texts = bandTexts[i] || [];
      if (texts.length > 1) {
        bandWithMultipleTexts = i;
        break;
      }
    }
    
    for (let i = 1; i <= ribbonCount; i++) {
      const btn = document.querySelector(`.btn-upload-excel[data-band="${i}"]`);
      const input = document.getElementById(`band${i}`);
      
      if (!btn) continue;
      
      if (bandWithMultipleTexts === null) {
        btn.disabled = false;
        btn.style.opacity = '1';
        btn.style.cursor = 'pointer';
        if (input) input.disabled = false;
      } else if (bandWithMultipleTexts === i) {
        btn.disabled = false;
        btn.style.opacity = '1';
        btn.style.cursor = 'pointer';
        if (input) input.disabled = true;
      } else {
        btn.disabled = true;
        btn.style.opacity = '0.5';
        btn.style.cursor = 'not-allowed';
        if (input) input.disabled = false;
      }
    }
  }

  // =====================
  // Update the visibility of the text field for the ribbon
  // =====================
  function updateBandFieldVisibility(bandIndex) {
    const textarea = document.getElementById(`band${bandIndex}`);
    const counter = document.getElementById(`band${bandIndex}-counter`);
    
    if (!textarea) return;
    
    const texts = bandTexts[bandIndex] || [];
    
    if (texts.length > 1) {
      textarea.style.display = 'none';
      if (counter) counter.style.display = 'none';
    } else {
      textarea.style.display = 'block';
      if (counter) counter.style.display = 'block';
    }
  }


  // =====================
  // Validation and limitation of text in textarea
  // =====================
  function validateBandText(textarea) {
    const maxLines  = parseInt(textarea.dataset.maxLines)  || EXCEL_CONFIG.maxLines;
    const maxLength = parseInt(textarea.dataset.maxLength) || EXCEL_CONFIG.maxLineLength;

    let lines = textarea.value.split('\n');
    let modified = false;
    
    if (lines.length > maxLines) {
      lines = lines.slice(0, maxLines);
      modified = true;
    }
    
    lines = lines.map(line => {
      if (line.length > maxLength) {
        modified = true;
        return line.substring(0, maxLength);
      }
      return line;
    });
    
    if (modified) {
      const cursorPos = textarea.selectionStart;
      textarea.value = lines.join('\n');
      textarea.setSelectionRange(cursorPos, cursorPos);
    }
    
    updateCharCounter(textarea);
  }

  // =====================
  // Refresh character counter
  // =====================
  function updateCharCounter(textarea) {
    const bandIndex = textarea.dataset.band;
    const maxLines  = parseInt(textarea.dataset.maxLines)  || EXCEL_CONFIG.maxLines;
    const maxLength = parseInt(textarea.dataset.maxLength) || EXCEL_CONFIG.maxLineLength;
    const counter   = document.getElementById(`band${bandIndex}-counter`);

    if (!counter) return;

    const lines = textarea.value.split('\n');

    counter.innerHTML = Array.from({length: maxLines}, (_, i) => {
      const len   = (lines[i] || '').length;
      const color = len > maxLength ? 'red' : '#666';
      return `<small style="color:${color};">${T.charCounter} ${i + 1}: ${len}/${maxLength}</small>`;
    }).join(' | ');
  }

  // =====================
  // Excel processing for a specific feed
  // =====================
  function processExcelForBand(file, bandIndex) {
    console.log(`📄 Processing Excel for Band ${bandIndex}:`, file.name);

    const fileExtension = '.' + file.name.split('.').pop().toLowerCase();
    
    if (!EXCEL_CONFIG.supportedFormats.includes(fileExtension)) {
      alert(T.msgInvalidFile);
      return;
    }

    const reader = new FileReader();
    
    reader.onload = function(e) {
      try {
        let rawData;
        
        if (fileExtension === '.csv') {
          const csvText = e.target.result;
          const lines = csvText.split('\n').filter(line => line.trim());
          rawData = lines.map(line => {
            return line.split(',').map(cell => cell.trim().replace(/^["']|["']$/g, ''));
          });
        } else {
          if (typeof XLSX === 'undefined') {
            alert('XLSX library not loaded');
            return;
          }
          
          const workbook = XLSX.read(e.target.result, { type: 'array' });
          const sheet = workbook.Sheets[workbook.SheetNames[0]];
          rawData = XLSX.utils.sheet_to_json(sheet, { header: 1 });
        }
        
        processExcelDataForBand(rawData, bandIndex);
      } catch (error) {
        console.error('Error processing file:', error);
        alert(T.msgError + ': ' + error.message);
      }
    };
    
    if (fileExtension === '.csv') {
      reader.readAsText(file);
    } else {
      reader.readAsArrayBuffer(file);
    }
  }


  // =====================
  // Excel Data Processing for a Ribbon
  // =====================
  function processExcelDataForBand(rawData, bandIndex) {
    // Reading limits from textarea
    const textarea  = document.getElementById(`band${bandIndex}`);
    const maxLines  = textarea ? (parseInt(textarea.dataset.maxLines)  || EXCEL_CONFIG.maxLines)      : EXCEL_CONFIG.maxLines;
    const maxLength = textarea ? (parseInt(textarea.dataset.maxLength) || EXCEL_CONFIG.maxLineLength) : EXCEL_CONFIG.maxLineLength;

    console.log(`📊 Processing data for Band ${bandIndex}:`, rawData.length, "rows");

    if (rawData.length === 0) {
      alert(T.msgNoData);
      return;
    }

    const dataRows = rawData.slice(0, EXCEL_CONFIG.maxRows);
    const texts = [];

    dataRows.forEach((row, rowIndex) => {
      const cell = row[0];
      if (cell && cell.toString().trim()) {
        let text = cell.toString().trim();
        
        let lines = text.split('\n').slice(0, maxLines);
        lines = lines.map(line => line.substring(0, maxLength));
        const limitedText = lines.join('\n');
        
        if (limitedText.length > 0) {
          texts.push({
            id: Date.now() + rowIndex,
            value: limitedText,
            original: text,
            isOverLimit: text.length > (maxLength * maxLines + maxLines - 1),
            quantity: 1,
            enabled: true
          });
        }
      }
    });

    if (texts.length === 0) {
      alert(T.msgNoData);
      return;
    }

    bandTexts[bandIndex] = texts;
    updateBandPreview(bandIndex);
    updateTotalQuantity();
    updateExcelButtonsState();
    alert(T.msgUploaded.replace('{count}', texts.length));
  }


  // =====================
  // Update band preview
  // =====================
  function updateBandPreview(bandIndex) {
    const preview = document.getElementById(`band${bandIndex}-preview`);
    const list = document.getElementById(`band${bandIndex}-list`);
    
    if (!preview || !list) return;

    const texts = bandTexts[bandIndex] || [];
    
    if (texts.length === 0) {
      preview.style.display = 'none';
      return;
    }

    preview.style.display = 'block';
    preview.querySelector('small').textContent = T.msgUploaded.replace('{count}', texts.length);

    let html = '<table style="width:100%;border-collapse:collapse;font-size:13px;">';
    html += '<thead><tr style="background:#f5f5f5;">';
    html += `<th style="padding:5px;text-align:left;">Text</th>`;
    html += `<th style="padding:5px;text-align:center;width:80px;">${T.quantity}</th>`;
    html += `<th style="padding:5px;text-align:center;width:50px;">❌</th>`;
    html += '</tr></thead><tbody>';

    texts.forEach((text, index) => {
      const textColor = text.isOverLimit ? 'red' : 'inherit';
      
      html += `<tr style="background:white;">`;
      html += `<td style="padding:5px;color:${textColor};">${text.value}</td>`;
      html += `<td style="padding:5px;text-align:center;">
        <input type="number" min="1" value="${text.quantity}" 
          class="band-text-qty" data-band="${bandIndex}" data-index="${index}"
          style="width:60px;padding:2px;border:1px solid #ccc;border-radius:3px;">
      </td>`;
      html += `<td style="padding:5px;text-align:center;">
        <button type="button" onclick="deleteBandText(${bandIndex}, ${index})" 
          style="background:none;border:none;cursor:pointer;font-size:18px;color:#f44336;">×</button>
      </td>`;
      html += '</tr>';
    });

    html += '</tbody></table>';
    list.innerHTML = html;

    setupBandTextHandlers(bandIndex);
    updateBandFieldVisibility(bandIndex);
  }


  // =====================
  // Feed Text Handlers
  // =====================
  function setupBandTextHandlers(bandIndex) {
    document.querySelectorAll(`.band-text-qty[data-band="${bandIndex}"]`).forEach(input => {
      input.addEventListener('change', function() {
        const index = parseInt(this.dataset.index);
        if (bandTexts[bandIndex][index]) {
          bandTexts[bandIndex][index].quantity = Math.max(1, parseInt(this.value) || 1);
          updateTotalQuantity();
        }
      });
    });
  }


  // =====================
  // Global functions for text management
  // =====================
  window.deleteAllBandTexts = function(bandIndex) {
    const texts = bandTexts[bandIndex] || [];
    
    if (texts.length === 0) {
      return;
    }

    if (confirm(`Alle ${texts.length} Text(e) wirklich löschen?`)) {
      bandTexts[bandIndex] = [];
      updateBandPreview(bandIndex);
      updateTotalQuantity();
      updateExcelButtonsState();
    }
  };

  window.deleteBandText = function(bandIndex, index) {
    if (confirm('Diesen Text wirklich löschen?')) {
      bandTexts[bandIndex].splice(index, 1);
      updateBandPreview(bandIndex);
      updateTotalQuantity();
      updateExcelButtonsState();
    }
  };

  // =====================
  // Clear center data when changing type
  // =====================
  function clearCenterDataOnTypeChange(newType) {
    // We check via matchOption to take into account both legacy and new values
    if (matchOption(newType, 'optionBlank') || matchOption(newType, 'optionStandard')) {
      const hiddenInput = document.getElementById('selected-template-url');
      const isTemplateSelected = hiddenInput && hiddenInput.value;
      
      if (!isTemplateSelected && currentImageUrl && currentImageUrl.includes('cloudinary.com')) {
        console.log('🧹 Clearing Cloudinary image on type change to', newType);
        currentImageUrl = '';
        currentImagePublicId = '';
        updateImagePreview(null, null);
      }
    }
    
    if (!matchOption(newType, 'optionStandard')) {
      const hiddenInput = document.getElementById('selected-template-url');
      if (hiddenInput) {
        hiddenInput.value = '';
      }
      
      if (currentImageUrl && !currentImageUrl.includes('cloudinary.com')) {
        console.log('🧹 Clearing template on type change from Vorlagen');
        currentImageUrl = '';
        updateImagePreview(null, null);
      }
    }
    
    if (!matchOption(newType, 'optionDigital')) {
      const materialSelect = document.getElementById('zentrum-material');
      if (materialSelect) {
        materialSelect.value = T.materialPlastic;
      }
    }
  }

  // =====================
  // Processors for Zentrumstyp
  // =====================
  async function setupZentrumTypeHandlers() {
    const zentrumSelect = document.getElementById("zentrumstyp");
    const colorContainer = document.getElementById("zentrum-color-container");
    const materialContainer = document.getElementById("zentrum-material-container");
    const uploadContainer = document.getElementById("upload-container");

    if (!zentrumSelect || !colorContainer || !uploadContainer) return;

    async function updateVisibility() {
      const value = zentrumSelect.value;
      
      clearCenterDataOnTypeChange(value);
      
      colorContainer.style.display = "none";
      materialContainer.style.display = "none";
      uploadContainer.style.display = "none";
      
      const templatesContainer = document.getElementById("zentrum-templates-container");
      if (templatesContainer) templatesContainer.style.display = "none";
      
      // Use matchOption to support legacy and new values
      if (matchOption(value, 'optionBlank')) {
        colorContainer.style.display = "block";
        await populateColorDropdown();
        
      } else if (matchOption(value, 'optionStandard')) {
        colorContainer.style.display = "block";
        
        const templatesContainer = document.getElementById("zentrum-templates-container");
        if (templatesContainer) templatesContainer.style.display = "block";
        
        await populateColorDropdown();
        await populateTemplatesGallery();
        
      } else if (matchOption(value, 'optionDigital')) {
        materialContainer.style.display = "block";
        uploadContainer.style.display = "block";
        
      } else if (matchOption(value, 'optionFoil')) {
        colorContainer.style.display = "block";
        uploadContainer.style.display = "block";
        await populateColorDropdown();
      }
    }

    zentrumSelect.addEventListener("change", updateVisibility);
    await updateVisibility();

    // Notify ES when the center type changes
    zentrumSelect.addEventListener("change", () => {
      document.dispatchEvent(new CustomEvent('kb:zentrumTypeChanged', {
        detail: { value: zentrumSelect.value }
      }));
    });
  }


  // =====================
  // Add buttons to products
  // =====================
  async function addIndividualisierungButtons() {
    try {
      const cart = await fetch("/cart.js").then(r => r.json());

      if (!cart.items || cart.items.length === 0) return;

      cart.items.forEach((item) => {
        try {
          const key = item.key;
          const title = item.title || item.product_title || "";

          if (!key) return;
          if (!checkProductTitle(title, item.sku)) return;

          const escapedKey = escapeSelector(key);
          const itemEl = document.querySelector(`#product-id-${escapedKey}`) 
                      || document.querySelector(`[data-product-id="${key}"]`);
          
          if (!itemEl) return;
          if (itemEl.querySelector(".btn-individualisierung")) return;

          const button = document.createElement("button");
          button.className = "btn-individualisierung";
          button.type = "button";
          button.textContent = T.btnOpen;
          button.style.cssText = `
            background:#fff;border:2px solid #910045;color:#910045;
            padding:8px 16px;margin-top:10px;cursor:pointer;font-size:13px;
            font-weight:bold;border-radius:0px;transition:all 0.3s;
            display:block;width:100%;text-align:center;
          `;
          button.dataset.key = key;
          button.dataset.sku = item.sku || '';

          button.addEventListener("mouseenter", () => {
            button.style.background = "#910045";
            button.style.color = "#fff";
          });
          button.addEventListener("mouseleave", () => {
            button.style.background = "#fff";
            button.style.color = "#910045";
          });

          if (item.properties && Object.keys(item.properties).length > 0) {
            button.textContent = T.btnEdit;
          }

          appendButtonToCartItem(itemEl, button);
          
        } catch (itemError) {
          console.error(`Error processing item:`, itemError);
        }
      });

    } catch (error) {
      console.error("Error adding buttons:", error);
    }
  }

  function handleButtonClick(e) {
    if (e.target.classList.contains("btn-individualisierung")) {
      e.preventDefault();
      e.stopPropagation();
      const key = e.target.dataset.key;
      openModal(key);
    }
  }

  function appendButtonToCartItem(itemEl, button) {
    const quantityBlock = itemEl.querySelector(".three.text-center");
    if (quantityBlock) {
      quantityBlock.appendChild(button);
    } else {
      const details = itemEl.querySelector(".item-details") || itemEl;
      details.appendChild(button);
    }
  }


  // =====================
  // Open modal
  // =====================
  async function openModal(key) {
    console.log("📖 Opening modal for key:", key);
    const modal = document.getElementById("individ-modal");
    modal.dataset.key = key;

    const item = await getCartItem(key);
    if (!item) {
      console.error("❌ Item not found in cart");
      return;
    }

    currentItemData = item;
    ribbonCount = await determineRibbonCount(item, key);
    
    bandTexts = {};
    currentImageUrl = '';
    currentImagePublicId = '';

    createRibbonFields(ribbonCount, key);
    
    const props = item.properties || {};
    const P = PROPERTY_NAMES[LANG] || PROPERTY_NAMES.de;

    // Заполняем существующие значения лент
    for (let i = 1; !isTextDisabled() && i <= ribbonCount; i++) {
      const inputEl = document.getElementById(`band${i}`);
      
      const parsedTexts = parseBandTextsFromProperties(i, props, key);
      
      if (parsedTexts.length > 1) {
        bandTexts[i] = parsedTexts;
        updateBandPreview(i);
      } else if (parsedTexts.length === 1) {
        if (inputEl) {
          inputEl.value = parsedTexts[0].value;
          if (inputEl.tagName === 'TEXTAREA') {
            updateCharCounter(inputEl);
          }
        }
      } else {
        const singleKey = `${P.band} ${i}`;
        if (inputEl && props[singleKey]) {
          inputEl.value = props[singleKey];
          if (inputEl.tagName === 'TEXTAREA') {
            updateCharCounter(inputEl);
          }
        }
      }
    }
    updateExcelButtonsState();

    // ✅ Zentrumstyp: читаем legacy или new, устанавливаем новое значение в select
    const zentrumSelect = document.getElementById("zentrumstyp");
    if (zentrumSelect) {
      // Read the stored value (can be legacy or new)
      const savedCenter = readProp(props, P, 'center');
      
      if (savedCenter) {
        // We determine which key corresponds to the stored value
        // and set the corresponding NEW value in select
        if (matchOption(savedCenter, 'optionBlank')) {
          zentrumSelect.value = T.optionBlank_new;
        } else if (matchOption(savedCenter, 'optionStandard')) {
          zentrumSelect.value = T.optionStandard_new;
        } else if (matchOption(savedCenter, 'optionDigital')) {
          zentrumSelect.value = T.optionDigital_new;
        } else if (matchOption(savedCenter, 'optionFoil')) {
          zentrumSelect.value = T.optionFoil_new;
        } else {
          // Unknown value - set as is (forward compatibility)
          zentrumSelect.value = savedCenter;
        }
      } else {
        zentrumSelect.value = T.optionBlank_new;
      }
    }

    // Preserving color for recovery after populateColorDropdown
    const savedCenterColor = readProp(props, P, 'centerColor') || '';

    // Material: Read legacy or new
    const materialSelect = document.getElementById("zentrum-material");
    if (materialSelect) {
      let materialValue = null;
      
      // First, let's try using readProp (new → legacy)
      materialValue = readProp(props, P, 'centerMaterial');
      
      // If you can't find it, try all the languages ​​(backward compatibility)
      if (!materialValue) {
        for (const langProps of Object.values(PROPERTY_NAMES)) {
          if (props[langProps.centerMaterial]) {
            materialValue = props[langProps.centerMaterial];
            break;
          }
          if (langProps.centerMaterial_new && props[langProps.centerMaterial_new]) {
            materialValue = props[langProps.centerMaterial_new];
            break;
          }
        }
      }

      // Normalize the material value: legacy → new
      if (materialValue) {
        if (matchOption(materialValue, 'materialMetall')) {
          materialSelect.value = T.materialMetall_new;
        } else {
          materialSelect.value = materialValue;
        }
      } else {
        materialSelect.value = T.materialPlastic;
      }
    }

    await setupZentrumTypeHandlers();

    const savedTemplateNo = props[P.templateNo] || '';
    const templateNoInput = document.getElementById('zentrum-template-no');
    if (templateNoInput && savedTemplateNo) {
      templateNoInput.value = savedTemplateNo;
    }
    
    // Restore color after loading dropdown
    if (savedCenterColor) {
      const colorSelect = document.getElementById("zentrum-color");
      if (colorSelect) {
        colorSelect.value = savedCenterColor;
      }
    }

    // Upload the image AFTER the gallery is created
    const savedImageUrl = readProp(props, P, 'imageUrl');
    const savedTemplateName = props[P.templateName];

    if (savedImageUrl || savedTemplateName) {
      if (savedTemplateName) {
        const templates = await loadCenterTemplates();
        const template = templates.find(t => t.title === savedTemplateName);
        
        if (template) {
          currentImageUrl = template.imageUrl;
          currentImageTitle = savedTemplateName;
          currentImageSource = 'template';
          
          updateImagePreview(template.imageUrl, savedTemplateName);
          
          const hiddenInput = document.getElementById('selected-template-url');
          if (hiddenInput) {
            hiddenInput.value = template.imageUrl;
          }
          
          await populateTemplatesGallery();
        }
      } else if (savedImageUrl) {
        if (savedImageUrl.includes('cloudinary.com')) {
          currentImageSource = 'cloudinary';
          currentImageUrl = savedImageUrl;
          
          const match = savedImageUrl.match(/\/upload\/(?:v\d+\/)?(.+)\.[^.]+$/);
          if (match) {
            currentImagePublicId = match[1];
            const thumbnailUrl = generateThumbnailUrl(currentImagePublicId, 150, 150);
            const filename = match[1].split('/').pop();
            currentImageTitle = filename;
            updateImagePreview(thumbnailUrl, filename);
          }
        }
      }
    }

    updateTotalQuantity();
    modal.style.display = "flex";

    // notify ES to open modals
    document.dispatchEvent(new CustomEvent('kb:modalOpened', {
      detail: { key, item, props, P }
    }));
  }


  // =====================
  // Saving
  // =====================
  async function saveIndividualisierung() {
    const key = document.getElementById("individ-modal").dataset.key;
    if (!key) return;

    console.log("💾 Saving...");

    const saveBtn = document.getElementById("individ-save");
    saveBtn.disabled = true;
    saveBtn.textContent = "...";

    const P = PROPERTY_NAMES[LANG] || PROPERTY_NAMES.de;
    
    const item = await getCartItem(key);
    const props = { ...(item.properties || {}) };
    
    let maxQuantity = 0;

    // We clear ALL variants of our keys (legacy and new) before writing
    // ✅ Удаляем ВСЕ текстовые ключи лент (все форматы и языки)
    const textDisabled = isTextDisabled();

    // We clear ALL variants of our keys (legacy and new) before writing
    // ✅ Удаляем ВСЕ текстовые ключи лент (все форматы и языки)
    if (!textDisabled) Object.keys(props).forEach(propKey => {
      // Пропускаем служебные ключи
      if (propKey.startsWith('_')) return;
      
      // Конфигураторские форматы (полный формат с "von/de/of/van/af")
      const configTextPatterns = [
        /^Text auf Band\s+\d+\s+von\s+\d+/i,                     // DE: "Text auf Band 1 von 3"
        /^Texto en (?:el )?cinta\s+\d+\s+de\s+\d+/i,             // ES: "Texto en el cinta 2 de 5"
        /^Text on ribbon\s+\d+\s+of\s+\d+/i,                     // EN: "Text on ribbon 3 of 5"
        /^Tekst op lint\s+\d+\s+van\s+\d+/i,                     // NL: "Tekst op lint 1 van 3"
        /^Tekst på bånd\s+\d+\s+af\s+\d+/i,                      // DK: "Tekst på bånd 2 af 3"
      ];
      
      // Простые форматы текстов лент (наш внутренний формат)
      const simpleTextPatterns = [
        /^Text auf Band\s+\d+(?:\s|$|\.)/i,                      // DE: "Text auf Band 1", "Text auf Band 1.1."
        /^Texto en (?:el )?cinta\s+\d+(?:\s|$|\.)/i,             // ES: "Texto en cinta 2", "Texto en el cinta 2.1."
        /^Text on ribbon\s+\d+(?:\s|$|\.)/i,                     // EN
        /^Tekst op lint\s+\d+(?:\s|$|\.)/i,                      // NL
        /^Tekst på bånd\s+\d+(?:\s|$|\.)/i,                      // DK
      ];
      
      // VIP+ форматы
      const vipPlusPatterns = [
        /VIP\+/i,                                                 // Любой ключ с VIP+
      ];
      
      // Проверяем все паттерны
      const allPatterns = [...configTextPatterns, ...simpleTextPatterns, ...vipPlusPatterns];
      
      for (const pattern of allPatterns) {
        if (pattern.test(propKey)) {
          delete props[propKey];
          break;
        }
      }
    });

    // ✅ Удаляем наши внутренние форматы (для подстраховки)
    for (let i = 1; !textDisabled && i <= 10; i++) {
      delete props[`${P.band} ${i}`];
      delete props[`${P.band} VIP+`];
      delete props[`${P.bandDetails} ${i}`];
      
      for (let j = 1; j <= 100; j++) {
        delete props[`${P.band} ${i}.${j}.`];
        delete props[`${P.band} ${i} (VIP).${j}.`];
        delete props[`${P.band} VIP+.${j}.`];
      }
    }   
    /*
    for (let i = 1; i <= 10; i++) {
      delete props[`${P.band} ${i}`];
      delete props[`${P.band} VIP+`];
      // 07.04.2026 delete props[`${P.bandQty} ${i}`];
      delete props[`${P.bandDetails} ${i}`];
      
      for (let j = 1; j <= 100; j++) {
        delete props[`${P.band} ${i}.${j}.`];
        delete props[`${P.band} ${i} (VIP).${j}.`];
        delete props[`${P.band} VIP+.${j}.`];
      }
    }
    */
    // We delete material for ALL keywords (legacy and new, all languages)
    Object.values(PROPERTY_NAMES).forEach(langProps => {
      delete props[langProps.centerMaterial];
      if (langProps.centerMaterial_new) delete props[langProps.centerMaterial_new];
    });

    // We delete the center by the legacy key if it differs from the new one.
    if (P.center !== P.center_new) {
      delete props[P.center];
    }

    // Remove centerColor by legacy key if it differs from new
    if (P.centerColor !== P.centerColor_new) {
      delete props[P.centerColor];
    }
    
    // We clear configuration texts if there are changes in the feeds
    let hasAnyBandChanges = false;

    for (let i = 1; i <= ribbonCount; i++) {
      const inputEl = document.getElementById(`band${i}`);
      const singleText = inputEl ? inputEl.value.trim() : '';
      const multiTexts = bandTexts[i] || [];
      
      if (singleText || multiTexts.length > 0) {
        hasAnyBandChanges = true;
        break;
      }
    }

    if (hasAnyBandChanges) {
      console.log('🧹 Cleaning configurator texts...');
      
      Object.keys(props).forEach(propKey => {
        if (propKey.startsWith('_')) return;
        
        const configTextPatterns = [
          /^Text auf Band\s+\d+\s+von\s+\d+/i,
          /^Texto en cinta\s+\d+\s+de\s+\d+/i,
          /^Text on ribbon\s+\d+\s+of\s+\d+/i,
          /^Tekst op lint\s+\d+\s+van\s+\d+/i,
          /^Tekst på bånd\s+\d+\s+af\s+\d+/i,
        ];
        
        for (const pattern of configTextPatterns) {
          if (pattern.test(propKey)) {
            delete props[propKey];
            console.log(`   ❌ Deleted: ${propKey}`);
            break;
          }
        }
      });
    }

    // We count the quantity
    let hasMultipleTexts = false;
    for (let i = 1; i <= ribbonCount; i++) {
      const multiTexts = bandTexts[i] || [];
      if (multiTexts.length > 1) {
        hasMultipleTexts = true;
        break;
      }
    }

    if (hasMultipleTexts) {
      for (let i = 1; i <= ribbonCount; i++) {
        const multiTexts = bandTexts[i] || [];
        
        if (multiTexts.length > 0) {
          const totalQty = multiTexts.reduce((sum, t) => sum + t.quantity, 0);
          maxQuantity = Math.max(maxQuantity, totalQty);
        }
      }
    } else {
      maxQuantity = item.quantity;
      console.log('📦 No Excel data, keeping current quantity:', maxQuantity);
    }

    // Saving feeds
    for (let i = 1; !textDisabled && i <= ribbonCount; i++) {
      const inputEl = document.getElementById(`band${i}`);
      const bandType = inputEl ? inputEl.dataset.bandType : 'normal';
      const singleText = inputEl ? inputEl.value.trim() : '';
      const multiTexts = bandTexts[i] || [];
      
      let propKey = '';
      if (bandType === 'vip+') {
        propKey = `${P.band} VIP+`;
      } else if (bandType === 'vip') {
        propKey = `${P.band} ${i} (VIP)`;
      } else {
        propKey = `${P.band} ${i}`;
      }
      
      if (multiTexts.length > 0) {
        multiTexts.forEach((text, idx) => {
          const subKey = `${propKey}.${idx + 1}.`;
          props[subKey] = `${text.value} (×${text.quantity})`;
        });
        
        //07.04.2026 props[`${P.bandQty} ${i}`] = maxQuantity.toString();
        
        props[`${P.bandDetails} ${i}`] = JSON.stringify(
          multiTexts.map(t => ({ text: t.value, qty: t.quantity }))
        );
        
      } else if (singleText) {
        props[propKey] = singleText;
        //07.04.2026 props[`${P.bandQty} ${i}`] = maxQuantity.toString();
      }
    }

    // Zentrumstyp — always write a new value
    const zentrumSelect = document.getElementById("zentrumstyp");
    const center = zentrumSelect ? zentrumSelect.value : T.optionBlank_new;
    
    // Use a new key for recording (center_new if different from center)
    const centerWriteKey = P.center_new || P.center;
    if (center) props[centerWriteKey] = center;

    if (matchOption(center, 'optionBlank')) {
      const colorSelect = document.getElementById("zentrum-color");
      if (colorSelect && colorSelect.value) {
        // We write the color using a new key
        props[P.centerColor_new || P.centerColor] = colorSelect.value;
      }
      delete props[P.imageUrl];
      // 07.04.2026 delete props[P.centerQty];
      // We delete material for both keys
      delete props[P.centerMaterial];
      if (P.centerMaterial_new) delete props[P.centerMaterial_new];
      delete props[P.templateName];
      
    } else if (matchOption(center, 'optionStandard')) {
      const colorSelect = document.getElementById("zentrum-color");
      if (colorSelect && colorSelect.value) {
        props[P.centerColor_new || P.centerColor] = colorSelect.value;
      }
      
      if (currentImageUrl) {
        props[P.imageUrl] = currentImageUrl;
        // 07.04.2026 props[P.centerQty] = maxQuantity.toString();
        
        if (currentImageTitle) {
          props[P.templateName] = currentImageTitle;
        }
      }
      
      delete props[P.centerMaterial];
      if (P.centerMaterial_new) delete props[P.centerMaterial_new];
      delete props[P.templateNo]; 
      
    } else if (matchOption(center, 'optionDigital')) {
      const materialSelect = document.getElementById("zentrum-material");
      if (materialSelect && materialSelect.value) {
        // We are recording using a new key.
        props[P.centerMaterial_new || P.centerMaterial] = materialSelect.value;
      }
      
      if (currentImageUrl) {
        props[P.imageUrl] = currentImageUrl;
        //07.04.2026 props[P.centerQty] = maxQuantity.toString();
      }
      
      delete props[P.centerColor];
      if (P.centerColor_new) delete props[P.centerColor_new];
      delete props[P.templateName];
      
      const templateNoInput = document.getElementById('zentrum-template-no');
      if (templateNoInput && templateNoInput.value.trim()) {
        props[P.templateNo] = templateNoInput.value.trim();
      } else {
        delete props[P.templateNo];
      }      

    } else if (matchOption(center, 'optionFoil')) {
      const colorSelect = document.getElementById("zentrum-color");
      if (colorSelect && colorSelect.value) {
        props[P.centerColor_new || P.centerColor] = colorSelect.value;
      }
      
      if (currentImageUrl) {
        props[P.imageUrl] = currentImageUrl;
        // 07.04.2026 props[P.centerQty] = maxQuantity.toString();
      }
      
      delete props[P.centerMaterial];
      if (P.centerMaterial_new) delete props[P.centerMaterial_new];
      delete props[P.templateName];

      const templateNoInput = document.getElementById('zentrum-template-no');
      if (templateNoInput && templateNoInput.value.trim()) {
        props[P.templateNo] = templateNoInput.value.trim();
      } else {
        delete props[P.templateNo];
      }

    }

    console.log("Properties to save:", props);
    console.log("Total quantity:", maxQuantity);

    try {
      const response = await fetch("/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ 
          id: key, 
          quantity: maxQuantity,
          properties: props 
        })
      });

      if (!response.ok) {
        throw new Error(`Failed: ${response.status}`);
      }

      alert(T.msgSaved);
      closeModal();
      location.reload();
    } catch (e) {
      console.error("Error:", e);
      alert(T.msgError);
      saveBtn.disabled = false;
      saveBtn.textContent = T.btnSave;
    }
  }

  // =====================
  // Auxiliary
  // =====================
  function closeModal() {
    const modal = document.getElementById("individ-modal");
    if (modal) {
      modal.style.display = "none";
      modal.dataset.key = "";
    }
    currentItemData = {};
    bandTexts = {};
    currentImageUrl = '';
    currentImagePublicId = '';
    currentImageTitle = '';
    currentImageSource = '';
    ribbonCount = 3;
  }

  async function getCartItem(key) {
    const cart = await fetch("/cart.js").then(r => r.json());
    return cart.items.find(i => i.key === key);
  }

})();
